import React, { useState, useEffect } from 'react';
import { integrationDocsUrl } from '../../utils/integrationDocs';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './VendorDetailsPage.css';
import axiosInstance from '../api';
import i18n from '../../i18n';

const SI   = 'https://cdn.simpleicons.org';
const WIKI = 'https://upload.wikimedia.org/wikipedia/commons';
/* Clearbit Logo API — brand logos by domain, for vendors Simple Icons dropped for trademark. */
const CB   = (domain) => `https://www.google.com/s2/favicons?sz=64&domain=${domain}`;

const VENDOR_LOGOS = {
  aws:          `${WIKI}/9/93/Amazon_Web_Services_Logo.svg`,
  azure:        `${WIKI}/f/fa/Microsoft_Azure.svg`,
  gcp:          `${WIKI}/5/51/Google_Cloud_logo.svg`,
  github:       `${SI}/github/24292E`,
  gitlab:       `${SI}/gitlab/FC6D26`,
  jira:         `${SI}/jira/0052CC`,
  kubernetes:   `${SI}/kubernetes/326CE5`,
  datadog:      `${SI}/datadog/632CA6`,
  okta:         `${SI}/okta/007DC1`,
  googleworkspace: `${SI}/google/4285F4`,
  onelogin:     CB('onelogin.com'),
  jumpcloud:    CB('jumpcloud.com'),
  duo:          CB('duo.com'),
  pingone:      CB('pingidentity.com'),
  auth0:        `${SI}/auth0/EB5424`,
  clerk:        `${SI}/clerk/6C47FF`,
  postmark:     CB('postmarkapp.com'),
  jamf:         CB('jamf.com'),
  intune:       CB('microsoft.com'),
  kandji:       CB('kandji.io'),
  snowflake:    `${SI}/snowflake/29B5E8`,
  splunk:       `${SI}/splunk/000000`,
  pagerduty:    `${SI}/pagerduty/06AC38`,
  bitbucket:    `${SI}/bitbucket/0052CC`,
  digitalocean: `${SI}/digitalocean/0080FF`,
  newrelic:     `${SI}/newrelic/008C99`,
  cloudflare:   `${SI}/cloudflare/F38020`,
  sentry:       `${SI}/sentry/362D59`,
  microsoft:    `${WIKI}/4/44/Microsoft_logo.svg`,
  /* ---- catalog evidence vendor logos (Clearbit; onError → letter-tile) ---- */
  "ascend": "https://www.google.com/s2/favicons?sz=64&domain=ascend.com",
  "assurancelab": "https://www.google.com/s2/favicons?sz=64&domain=assurancelab.com",
  "audora": "https://www.google.com/s2/favicons?sz=64&domain=audora.com",
  "fieldguide": "https://www.google.com/s2/favicons?sz=64&domain=fieldguide.com",
  "trenta": "https://www.google.com/s2/favicons?sz=64&domain=trenta.com",
  "certn": "https://www.google.com/s2/favicons?sz=64&domain=certn.com",
  "checkr": "https://www.google.com/s2/favicons?sz=64&domain=checkr.com",
  "hirepass": "https://www.google.com/s2/favicons?sz=64&domain=hirepass.com",
  "veremark": "https://www.google.com/s2/favicons?sz=64&domain=veremark.com",
  "vetty": "https://www.google.com/s2/favicons?sz=64&domain=vetty.com",
  "zinc": "https://www.google.com/s2/favicons?sz=64&domain=zinc.com",
  "capsule": "https://www.google.com/s2/favicons?sz=64&domain=capsule.com",
  "close": "https://www.google.com/s2/favicons?sz=64&domain=close.com",
  "copper": "https://www.google.com/s2/favicons?sz=64&domain=copper.com",
  "hubspot": "https://www.google.com/s2/favicons?sz=64&domain=hubspot.com",
  "insightly": "https://www.google.com/s2/favicons?sz=64&domain=insightly.com",
  "salesforce": "https://www.google.com/s2/favicons?sz=64&domain=salesforce.com",
  "zendesk": "https://www.google.com/s2/favicons?sz=64&domain=zendesk.com",
  "amazonecr": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "awsgovcloud": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "digitaloceanspaces": "https://www.google.com/s2/favicons?sz=64&domain=digitalocean.com",
  "gcpartifact": "https://www.google.com/s2/favicons?sz=64&domain=cloud.google.com",
  "grafanacloud": "https://www.google.com/s2/favicons?sz=64&domain=grafana.com",
  "heroku": "https://www.google.com/s2/favicons?sz=64&domain=heroku.com",
  "netlify": "https://www.google.com/s2/favicons?sz=64&domain=netlify.com",
  "oci": "https://www.google.com/s2/favicons?sz=64&domain=oracle.com",
  "ovhcloud": "https://www.google.com/s2/favicons?sz=64&domain=ovhcloud.com",
  "railway": "https://www.google.com/s2/favicons?sz=64&domain=railway.app",
  "render": "https://www.google.com/s2/favicons?sz=64&domain=render.com",
  "scaleway": "https://www.google.com/s2/favicons?sz=64&domain=scaleway.com",
  vercel:       `${SI}/vercel/000000`,
  "intercom": "https://www.google.com/s2/favicons?sz=64&domain=intercom.com",
  "zoom": "https://www.google.com/s2/favicons?sz=64&domain=zoom.us",
  "databricks": "https://www.google.com/s2/favicons?sz=64&domain=databricks.com",
  "mongoatlas": "https://www.google.com/s2/favicons?sz=64&domain=mongodb.com",
  "box": "https://www.google.com/s2/favicons?sz=64&domain=box.com",
  "dropbox": "https://www.google.com/s2/favicons?sz=64&domain=dropbox.com",
  "googledrive": "https://www.google.com/s2/favicons?sz=64&domain=google.com",
  "guru": "https://www.google.com/s2/favicons?sz=64&domain=guru.com",
  "microsoftsharepoint": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "notion": "https://www.google.com/s2/favicons?sz=64&domain=notion.so",
  "pima": "https://www.google.com/s2/favicons?sz=64&domain=pima.com",
  "agency": "https://www.google.com/s2/favicons?sz=64&domain=agency.com",
  "automox": "https://www.google.com/s2/favicons?sz=64&domain=automox.com",
  "hexnode": "https://www.google.com/s2/favicons?sz=64&domain=hexnode.com",
  "kitecyber": "https://www.google.com/s2/favicons?sz=64&domain=kitecyber.com",
  "7shifts": "https://www.google.com/s2/favicons?sz=64&domain=7shifts.com",
  "adpworkforce": "https://www.google.com/s2/favicons?sz=64&domain=adp.com",
  "alexishr": "https://www.google.com/s2/favicons?sz=64&domain=alexishr.com",
  "alterapayroll": "https://www.google.com/s2/favicons?sz=64&domain=alterapayroll.com",
  "bamboohr": "https://www.google.com/s2/favicons?sz=64&domain=bamboohr.com",
  "bob": "https://www.google.com/s2/favicons?sz=64&domain=bob.com",
  "breathe": "https://www.google.com/s2/favicons?sz=64&domain=breathe.com",
  "breezyhr": "https://www.google.com/s2/favicons?sz=64&domain=breezyhr.com",
  "breezyhrx": "https://www.google.com/s2/favicons?sz=64&domain=breezyhr.com",
  "central": "https://www.google.com/s2/favicons?sz=64&domain=central.com",
  "dayforce": "https://www.google.com/s2/favicons?sz=64&domain=dayforce.com",
  "charliehr": "https://www.google.com/s2/favicons?sz=64&domain=charliehr.com",
  "clayhr": "https://www.google.com/s2/favicons?sz=64&domain=clayhr.com",
  "cyberark": "https://www.google.com/s2/favicons?sz=64&domain=cyberark.com",
  "deel": "https://www.google.com/s2/favicons?sz=64&domain=deel.com",
  "employmenthero": "https://www.google.com/s2/favicons?sz=64&domain=employmenthero.com",
  "factorial": "https://www.google.com/s2/favicons?sz=64&domain=factorial.com",
  "freshteam": "https://www.google.com/s2/favicons?sz=64&domain=freshworks.com",
  "gusto": "https://www.google.com/s2/favicons?sz=64&domain=gusto.com",
  "hrcloud": "https://www.google.com/s2/favicons?sz=64&domain=hrcloud.com",
  "hrpartner": "https://www.google.com/s2/favicons?sz=64&domain=hrpartner.com",
  "humaans": "https://www.google.com/s2/favicons?sz=64&domain=humaans.com",
  "insperity": "https://www.google.com/s2/favicons?sz=64&domain=insperity.com",
  "intellihr": "https://www.google.com/s2/favicons?sz=64&domain=intellihr.com",
  "isolved": "https://www.google.com/s2/favicons?sz=64&domain=isolved.com",
  "justworks": "https://www.google.com/s2/favicons?sz=64&domain=justworks.com",
  "kallidus": "https://www.google.com/s2/favicons?sz=64&domain=kallidus.com",
  "keka": "https://www.google.com/s2/favicons?sz=64&domain=keka.com",
  "kenjo": "https://www.google.com/s2/favicons?sz=64&domain=kenjo.com",
  "lano": "https://www.google.com/s2/favicons?sz=64&domain=lano.com",
  "lucca": "https://www.google.com/s2/favicons?sz=64&domain=lucca.fr",
  "namely": "https://www.google.com/s2/favicons?sz=64&domain=namely.com",
  "netsuite": "https://www.google.com/s2/favicons?sz=64&domain=netsuite.com",
  "nmbrs": "https://www.google.com/s2/favicons?sz=64&domain=nmbrs.com",
  "officient": "https://www.google.com/s2/favicons?sz=64&domain=officient.com",
  "oraclecloudhcm": "https://www.google.com/s2/favicons?sz=64&domain=oracle.com",
  "oyster": "https://www.google.com/s2/favicons?sz=64&domain=oysterhr.com",
  "paycaptain": "https://www.google.com/s2/favicons?sz=64&domain=paycaptain.com",
  "paychexflex": "https://www.google.com/s2/favicons?sz=64&domain=paychex.com",
  "paycor": "https://www.google.com/s2/favicons?sz=64&domain=paycor.com",
  "payfit95f52": "https://www.google.com/s2/favicons?sz=64&domain=payfit.com",
  "paylocity": "https://www.google.com/s2/favicons?sz=64&domain=paylocity.com",
  "payworks": "https://www.google.com/s2/favicons?sz=64&domain=payworks.com",
  "peoplehr": "https://www.google.com/s2/favicons?sz=64&domain=peoplehr.com",
  "personio": "https://www.google.com/s2/favicons?sz=64&domain=personio.com",
  "proliant": "https://www.google.com/s2/favicons?sz=64&domain=proliant.com",
  "quickbooks": "https://www.google.com/s2/favicons?sz=64&domain=intuit.com",
  "remote": "https://www.google.com/s2/favicons?sz=64&domain=remote.com",
  "rippling": "https://www.google.com/s2/favicons?sz=64&domain=rippling.com",
  "sage": "https://www.google.com/s2/favicons?sz=64&domain=sage.com",
  "sagehr": "https://www.google.com/s2/favicons?sz=64&domain=sage.com",
  "sapsuccessfactors": "https://www.google.com/s2/favicons?sz=64&domain=sap.com",
  "sesame": "https://www.google.com/s2/favicons?sz=64&domain=sesame.com",
  "squarepayrollf5639": "https://www.google.com/s2/favicons?sz=64&domain=squarepayroll.com",
  "torii": "https://www.google.com/s2/favicons?sz=64&domain=torii.com",
  "trinet": "https://www.google.com/s2/favicons?sz=64&domain=trinet.com",
  "ukgdimensions": "https://www.google.com/s2/favicons?sz=64&domain=ukg.com",
  "ukgpro": "https://www.google.com/s2/favicons?sz=64&domain=ukg.com",
  "ukgready": "https://www.google.com/s2/favicons?sz=64&domain=ukg.com",
  "workable": "https://www.google.com/s2/favicons?sz=64&domain=workable.com",
  "workday": "https://www.google.com/s2/favicons?sz=64&domain=workday.com",
  "zenefits": "https://www.google.com/s2/favicons?sz=64&domain=zenefits.com",
  "azuread": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "office365": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "entragcchigh": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "sclaeai": "https://www.google.com/s2/favicons?sz=64&domain=scale.com",
  "breachrx": "https://www.google.com/s2/favicons?sz=64&domain=breachrx.com",
  "incident": "https://www.google.com/s2/favicons?sz=64&domain=incident.io",
  "addigy": "https://www.google.com/s2/favicons?sz=64&domain=addigy.com",
  "datto": "https://www.google.com/s2/favicons?sz=64&domain=datto.com",
  "edamametechnologies": "https://www.google.com/s2/favicons?sz=64&domain=edamame.technology",
  "fleet": "https://www.google.com/s2/favicons?sz=64&domain=fleetdm.com",
  "microsoftintune": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "iru": "https://www.google.com/s2/favicons?sz=64&domain=iru.com",
  "kolide": "https://www.google.com/s2/favicons?sz=64&domain=kolide.com",
  "manageengine": "https://www.google.com/s2/favicons?sz=64&domain=manageengine.com",
  "microsoftendpointmanager": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "intunegcchigh": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "miradore": "https://www.google.com/s2/favicons?sz=64&domain=miradore.com",
  "ninjaone": "https://www.google.com/s2/favicons?sz=64&domain=ninjaone.com",
  "omnissa": "https://www.google.com/s2/favicons?sz=64&domain=omnissa.com",
  "primo": "https://www.google.com/s2/favicons?sz=64&domain=primo.com",
  "simplemdm": "https://www.google.com/s2/favicons?sz=64&domain=simplemdm.com",
  "swif": "https://www.google.com/s2/favicons?sz=64&domain=swif.com",
  "trio": "https://www.google.com/s2/favicons?sz=64&domain=trio.com",
  "vmwareworkspaceone": "https://www.google.com/s2/favicons?sz=64&domain=vmware.com",
  "xcitium": "https://www.google.com/s2/favicons?sz=64&domain=xcitium.com",
  "xfa": "https://www.google.com/s2/favicons?sz=64&domain=xfa.com",
  "sumologic": "https://www.google.com/s2/favicons?sz=64&domain=sumologic.com",
  "1password": "https://www.google.com/s2/favicons?sz=64&domain=1password.com",
  "4me": "https://www.google.com/s2/favicons?sz=64&domain=4me.com",
  "8x8": "https://www.google.com/s2/favicons?sz=64&domain=8x8.com",
  "abv": "https://www.google.com/s2/favicons?sz=64&domain=abv.com",
  "accessowl": "https://www.google.com/s2/favicons?sz=64&domain=accessowl.com",
  "acunetix360": "https://www.google.com/s2/favicons?sz=64&domain=acunetix360.com",
  "adobelearning": "https://www.google.com/s2/favicons?sz=64&domain=adobelearningmanager.com",
  "airtable": "https://www.google.com/s2/favicons?sz=64&domain=airtable.com",
  "akamai": "https://www.google.com/s2/favicons?sz=64&domain=akamai.com",
  "alertmedia": "https://www.google.com/s2/favicons?sz=64&domain=alertmedia.com",
  "amplitude": "https://www.google.com/s2/favicons?sz=64&domain=amplitude.com",
  "anthropic": "https://www.google.com/s2/favicons?sz=64&domain=anthropic.com",
  "apollo": "https://www.google.com/s2/favicons?sz=64&domain=apollo.com",
  "appaegis76b4c": "https://www.google.com/s2/favicons?sz=64&domain=appaegis.com",
  "applebusinessmanager": "https://www.google.com/s2/favicons?sz=64&domain=apple.com",
  "appranix": "https://www.google.com/s2/favicons?sz=64&domain=appranix.com",
  "ashby": "https://www.google.com/s2/favicons?sz=64&domain=ashbyhq.com",
  "assetpanda": "https://www.google.com/s2/favicons?sz=64&domain=assetpanda.com",
  "axisatmos": "https://www.google.com/s2/favicons?sz=64&domain=atmos.com",
  "autodesk": "https://www.google.com/s2/favicons?sz=64&domain=autodesk.com",
  "azuresynapse": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "bis": "https://www.google.com/s2/favicons?sz=64&domain=bis.com",
  "bitwarden": "https://www.google.com/s2/favicons?sz=64&domain=bitwarden.com",
  "blink": "https://www.google.com/s2/favicons?sz=64&domain=blink.com",
  "blinq": "https://www.google.com/s2/favicons?sz=64&domain=blinq.com",
  "blogin": "https://www.google.com/s2/favicons?sz=64&domain=blogin.com",
  "bluejeans": "https://www.google.com/s2/favicons?sz=64&domain=bluejeans.com",
  "bocada": "https://www.google.com/s2/favicons?sz=64&domain=bocada.com",
  "brex": "https://www.google.com/s2/favicons?sz=64&domain=brex.com",
  "britive": "https://www.google.com/s2/favicons?sz=64&domain=britive.com",
  "browserstack": "https://www.google.com/s2/favicons?sz=64&domain=browserstack.com",
  "calendly": "https://www.google.com/s2/favicons?sz=64&domain=calendly.com",
  "cats": "https://www.google.com/s2/favicons?sz=64&domain=cats.com",
  "charthop": "https://www.google.com/s2/favicons?sz=64&domain=charthop.com",
  "checkproof": "https://www.google.com/s2/favicons?sz=64&domain=checkproof.com",
  "cinode": "https://www.google.com/s2/favicons?sz=64&domain=cinode.com",
  "cleanmailf734a": "https://www.google.com/s2/favicons?sz=64&domain=cleanmail.com",
  "clebex": "https://www.google.com/s2/favicons?sz=64&domain=clebex.com",
  "clockworkrecruiter": "https://www.google.com/s2/favicons?sz=64&domain=clockworkrecruiting.com",
  "cloudback": "https://www.google.com/s2/favicons?sz=64&domain=cloudback.com",
  "coda": "https://www.google.com/s2/favicons?sz=64&domain=coda.com",
  "comeet": "https://www.google.com/s2/favicons?sz=64&domain=comeet.com",
  "commonpaper": "https://www.google.com/s2/favicons?sz=64&domain=commonpaper.com",
  "confluence": "https://www.google.com/s2/favicons?sz=64&domain=atlassian.com",
  "contentful": "https://www.google.com/s2/favicons?sz=64&domain=contentful.com",
  "continuitystrength": "https://www.google.com/s2/favicons?sz=64&domain=continuitystrength.com",
  "cside": "https://www.google.com/s2/favicons?sz=64&domain=cside.com",
  "cybsafe": "https://www.google.com/s2/favicons?sz=64&domain=cybsafe.com",
  "dashlane": "https://www.google.com/s2/favicons?sz=64&domain=dashlane.com",
  "dbtlab": "https://www.google.com/s2/favicons?sz=64&domain=dbtlabs.com",
  "dockerhub": "https://www.google.com/s2/favicons?sz=64&domain=docker.com",
  "documo": "https://www.google.com/s2/favicons?sz=64&domain=documo.com",
  "docusign": "https://www.google.com/s2/favicons?sz=64&domain=docusign.com",
  "doppler": "https://www.google.com/s2/favicons?sz=64&domain=doppler.com",
  "drift": "https://www.google.com/s2/favicons?sz=64&domain=drift.com",
  "dynatrace": "https://www.google.com/s2/favicons?sz=64&domain=dynatrace.com",
  "elastic": "https://www.google.com/s2/favicons?sz=64&domain=elastic.co",
  "eletive": "https://www.google.com/s2/favicons?sz=64&domain=eletive.com",
  "elium": "https://www.google.com/s2/favicons?sz=64&domain=elium.com",
  "envkey": "https://www.google.com/s2/favicons?sz=64&domain=envkey.com",
  "envoy": "https://www.google.com/s2/favicons?sz=64&domain=envoy.com",
  "evervault": "https://www.google.com/s2/favicons?sz=64&domain=evervault.com",
  "exium": "https://www.google.com/s2/favicons?sz=64&domain=exium.com",
  "faceup": "https://www.google.com/s2/favicons?sz=64&domain=faceup.com",
  "figma": "https://www.google.com/s2/favicons?sz=64&domain=figma.com",
  "fivetran": "https://www.google.com/s2/favicons?sz=64&domain=fivetran.com",
  "flock": "https://www.google.com/s2/favicons?sz=64&domain=flock.com",
  "foodee": "https://www.google.com/s2/favicons?sz=64&domain=foodee.com",
  "fourfour": "https://www.google.com/s2/favicons?sz=64&domain=fourfour.com",
  "gdprlocal": "https://www.google.com/s2/favicons?sz=64&domain=gdprlocal.com",
  "ghostable": "https://www.google.com/s2/favicons?sz=64&domain=ghostable.com",
  "gong": "https://www.google.com/s2/favicons?sz=64&domain=gong.com",
  "grammarly": "https://www.google.com/s2/favicons?sz=64&domain=grammarly.com",
  "greenhouse": "https://www.google.com/s2/favicons?sz=64&domain=greenhouse.io",
  "griffo": "https://www.google.com/s2/favicons?sz=64&domain=griffo.com",
  "h5mag": "https://www.google.com/s2/favicons?sz=64&domain=h5mag.com",
  "harness": "https://www.google.com/s2/favicons?sz=64&domain=harness.io",
  "harvest": "https://www.google.com/s2/favicons?sz=64&domain=harvest.com",
  "helloid": "https://www.google.com/s2/favicons?sz=64&domain=helloid.com",
  "hootsuite": "https://www.google.com/s2/favicons?sz=64&domain=hootsuite.com",
  "hoxhunt": "https://www.google.com/s2/favicons?sz=64&domain=hoxhunt.com",
  "ideagen": "https://www.google.com/s2/favicons?sz=64&domain=ideagen.com",
  "ideo": "https://www.google.com/s2/favicons?sz=64&domain=ideo.com",
  "invision": "https://www.google.com/s2/favicons?sz=64&domain=invision.com",
  "jobadder": "https://www.google.com/s2/favicons?sz=64&domain=jobadder.com",
  "jobvite": "https://www.google.com/s2/favicons?sz=64&domain=jobvite.com",
  "jostle": "https://www.google.com/s2/favicons?sz=64&domain=jostle.com",
  "junojourney": "https://www.google.com/s2/favicons?sz=64&domain=junojourney.com",
  "keeper": "https://www.google.com/s2/favicons?sz=64&domain=keepersecurity.com",
  "kpifire": "https://www.google.com/s2/favicons?sz=64&domain=kpifire.com",
  "lastpass": "https://www.google.com/s2/favicons?sz=64&domain=lastpass.com",
  "lattice": "https://www.google.com/s2/favicons?sz=64&domain=lattice.com",
  "latticeflowai": "https://www.google.com/s2/favicons?sz=64&domain=latticeflowai.com",
  "launchdarkly": "https://www.google.com/s2/favicons?sz=64&domain=launchdarkly.com",
  "leapsome": "https://www.google.com/s2/favicons?sz=64&domain=leapsome.com",
  "lever": "https://www.google.com/s2/favicons?sz=64&domain=lever.co",
  "logicgate": "https://www.google.com/s2/favicons?sz=64&domain=logicgate.com",
  "loom": "https://www.google.com/s2/favicons?sz=64&domain=loom.com",
  "looop": "https://www.google.com/s2/favicons?sz=64&domain=looop.com",
  "lucid": "https://www.google.com/s2/favicons?sz=64&domain=lucid.com",
  "appaegis": "https://www.google.com/s2/favicons?sz=64&domain=appaegis.com",
  "maptician": "https://www.google.com/s2/favicons?sz=64&domain=maptician.com",
  "metapulse": "https://www.google.com/s2/favicons?sz=64&domain=metapulse.com",
  "mindtickle": "https://www.google.com/s2/favicons?sz=64&domain=mindtickle.com",
  "miro": "https://www.google.com/s2/favicons?sz=64&domain=miro.com",
  "mixpanel": "https://www.google.com/s2/favicons?sz=64&domain=mixpanel.com",
  "mode": "https://www.google.com/s2/favicons?sz=64&domain=mode.com",
  "multiplier": "https://www.google.com/s2/favicons?sz=64&domain=usemultiplier.com",
  "mypolicies": "https://www.google.com/s2/favicons?sz=64&domain=mypolicies.com",
  "nordpass": "https://www.google.com/s2/favicons?sz=64&domain=nordpass.com",
  "openai": "https://www.google.com/s2/favicons?sz=64&domain=openai.com",
  "opsbook": "https://www.google.com/s2/favicons?sz=64&domain=opsbook.com",
  "opsgenie1f68e": "https://www.google.com/s2/favicons?sz=64&domain=opsgenie.com",
  "opslevel": "https://www.google.com/s2/favicons?sz=64&domain=opslevel.com",
  "osano": "https://www.google.com/s2/favicons?sz=64&domain=osano.com",
  "parsable": "https://www.google.com/s2/favicons?sz=64&domain=parsable.com",
  "peakon": "https://www.google.com/s2/favicons?sz=64&domain=peakon.com",
  "peripass": "https://www.google.com/s2/favicons?sz=64&domain=peripass.com",
  "phalanx": "https://www.google.com/s2/favicons?sz=64&domain=phalanx.com",
  "pipedrive": "https://www.google.com/s2/favicons?sz=64&domain=pipedrive.com",
  "postman": "https://www.google.com/s2/favicons?sz=64&domain=postman.com",
  "prioritymatrix": "https://www.google.com/s2/favicons?sz=64&domain=prioritymatrix.com",
  "probackupbv": "https://www.google.com/s2/favicons?sz=64&domain=probackupbv.com",
  "prodpad": "https://www.google.com/s2/favicons?sz=64&domain=prodpad.com",
  "productboard": "https://www.google.com/s2/favicons?sz=64&domain=productboard.com",
  "qlik": "https://www.google.com/s2/favicons?sz=64&domain=qlik.com",
  "ramp": "https://www.google.com/s2/favicons?sz=64&domain=ramp.com",
  "ravenna": "https://www.google.com/s2/favicons?sz=64&domain=ravenna.com",
  "reportit": "https://www.google.com/s2/favicons?sz=64&domain=reportit.com",
  "rfpio": "https://www.google.com/s2/favicons?sz=64&domain=rfpio.com",
  "retool": "https://www.google.com/s2/favicons?sz=64&domain=retool.com",
  "robin": "https://www.google.com/s2/favicons?sz=64&domain=robin.com",
  "rockset": "https://www.google.com/s2/favicons?sz=64&domain=rockset.com",
  "rollbar": "https://www.google.com/s2/favicons?sz=64&domain=rollbar.com",
  "scaleai": "https://www.google.com/s2/favicons?sz=64&domain=scale.com",
  "securily": "https://www.google.com/s2/favicons?sz=64&domain=securily.com",
  "segment": "https://www.google.com/s2/favicons?sz=64&domain=segment.com",
  "shopify": "https://www.google.com/s2/favicons?sz=64&domain=shopify.com",
  "sigma": "https://www.google.com/s2/favicons?sz=64&domain=sigmacomputing.com",
  "simplebackups": "https://www.google.com/s2/favicons?sz=64&domain=simplebackups.com",
  "slab": "https://www.google.com/s2/favicons?sz=64&domain=slab.com",
  "smartfile": "https://www.google.com/s2/favicons?sz=64&domain=smartfile.com",
  "smartrecruiters": "https://www.google.com/s2/favicons?sz=64&domain=smartrecruiters.com",
  "sophos": "https://www.google.com/s2/favicons?sz=64&domain=sophos.com",
  "sparkhire": "https://www.google.com/s2/favicons?sz=64&domain=sparkhire.com",
  "speakupnow": "https://www.google.com/s2/favicons?sz=64&domain=speakupnow.com",
  "splashtop": "https://www.google.com/s2/favicons?sz=64&domain=splashtop.com",
  "statsig": "https://www.google.com/s2/favicons?sz=64&domain=statsig.com",
  "subrosa": "https://www.google.com/s2/favicons?sz=64&domain=subrosa.com",
  "supabase": "https://www.google.com/s2/favicons?sz=64&domain=supabase.com",
  "sym": "https://www.google.com/s2/favicons?sz=64&domain=sym.com",
  "tailscale": "https://www.google.com/s2/favicons?sz=64&domain=tailscale.com",
  "talentech": "https://www.google.com/s2/favicons?sz=64&domain=talentech.com",
  "teamtailor": "https://www.google.com/s2/favicons?sz=64&domain=teamtailor.com",
  "termius": "https://www.google.com/s2/favicons?sz=64&domain=termius.com",
  "timetoreply": "https://www.google.com/s2/favicons?sz=64&domain=timetoreply.com",
  "torq": "https://www.google.com/s2/favicons?sz=64&domain=torq.com",
  "travelperk": "https://www.google.com/s2/favicons?sz=64&domain=travelperk.com",
  "trelica": "https://www.google.com/s2/favicons?sz=64&domain=trelica.com",
  "tribeloo": "https://www.google.com/s2/favicons?sz=64&domain=tribeloo.com",
  "twingate": "https://www.google.com/s2/favicons?sz=64&domain=twingate.com",
  "unifi": "https://www.google.com/s2/favicons?sz=64&domain=unifi.com",
  "vendr": "https://www.google.com/s2/favicons?sz=64&domain=vendr.com",
  "vonage": "https://www.google.com/s2/favicons?sz=64&domain=vonage.com",
  "webex": "https://www.google.com/s2/favicons?sz=64&domain=webex.com",
  "whimsical": "https://www.google.com/s2/favicons?sz=64&domain=whimsical.com",
  "workplace": "https://www.google.com/s2/favicons?sz=64&domain=workplace.com",
  "xero": "https://www.google.com/s2/favicons?sz=64&domain=xero.com",
  "zapier": "https://www.google.com/s2/favicons?sz=64&domain=zapier.com",
  "zavanta": "https://www.google.com/s2/favicons?sz=64&domain=zavanta.com",
  "zero": "https://www.google.com/s2/favicons?sz=64&domain=zero.com",
  "zip": "https://www.google.com/s2/favicons?sz=64&domain=zip.com",
  "zoominfo": "https://www.google.com/s2/favicons?sz=64&domain=zoominfo.com",
  "360learning": "https://www.google.com/s2/favicons?sz=64&domain=360learning.com",
  "adaptivesecurity": "https://www.google.com/s2/favicons?sz=64&domain=adaptivesecurity.com",
  "awarego": "https://www.google.com/s2/favicons?sz=64&domain=awarego.com",
  "caniphish": "https://www.google.com/s2/favicons?sz=64&domain=caniphish.com",
  "cybeready": "https://www.google.com/s2/favicons?sz=64&domain=cybeready.com",
  "cyberly": "https://www.google.com/s2/favicons?sz=64&domain=cyberly.com",
  "easyllama": "https://www.google.com/s2/favicons?sz=64&domain=easyllama.com",
  "elba": "https://www.google.com/s2/favicons?sz=64&domain=elba.com",
  "ethena": "https://www.google.com/s2/favicons?sz=64&domain=ethena.com",
  "ghosteye": "https://www.google.com/s2/favicons?sz=64&domain=ghosteye.com",
  "haekka": "https://www.google.com/s2/favicons?sz=64&domain=haekka.com",
  "hooksecurity": "https://www.google.com/s2/favicons?sz=64&domain=hooksecurity.com",
  "curricula": "https://www.google.com/s2/favicons?sz=64&domain=huntress.com",
  "kamae": "https://www.google.com/s2/favicons?sz=64&domain=kamae.com",
  "knowbe4": "https://www.google.com/s2/favicons?sz=64&domain=knowbe4.com",
  "moxso": "https://www.google.com/s2/favicons?sz=64&domain=moxso.com",
  "ninjio": "https://www.google.com/s2/favicons?sz=64&domain=ninjio.com",
  "outkept": "https://www.google.com/s2/favicons?sz=64&domain=outkept.com",
  "outthink": "https://www.google.com/s2/favicons?sz=64&domain=outthink.com",
  "ransomleak": "https://www.google.com/s2/favicons?sz=64&domain=ransomleak.com",
  "riot": "https://www.google.com/s2/favicons?sz=64&domain=riot.com",
  "safestack": "https://www.google.com/s2/favicons?sz=64&domain=safestack.com",
  "smartfense": "https://www.google.com/s2/favicons?sz=64&domain=smartfense.com",
  "sosafe": "https://www.google.com/s2/favicons?sz=64&domain=sosafe.com",
  "talentlms": "https://www.google.com/s2/favicons?sz=64&domain=talentlms.com",
  "vansec": "https://www.google.com/s2/favicons?sz=64&domain=vansec.com",
  "wizer": "https://www.google.com/s2/favicons?sz=64&domain=wizer.com",
  "aha": "https://www.google.com/s2/favicons?sz=64&domain=aha.com",
  "asana": "https://www.google.com/s2/favicons?sz=64&domain=asana.com",
  "basecamp": "https://www.google.com/s2/favicons?sz=64&domain=basecamp.com",
  "clickup": "https://www.google.com/s2/favicons?sz=64&domain=clickup.com",
  "dixa": "https://www.google.com/s2/favicons?sz=64&domain=dixa.com",
  "freshdesk": "https://www.google.com/s2/favicons?sz=64&domain=freshworks.com",
  "freshservice": "https://www.google.com/s2/favicons?sz=64&domain=freshworks.com",
  "front": "https://www.google.com/s2/favicons?sz=64&domain=front.com",
  "githubissues": "https://www.google.com/s2/favicons?sz=64&domain=github.com",
  "gitlabissues": "https://www.google.com/s2/favicons?sz=64&domain=gitlab.com",
  "gitlabissuesonprem": "https://www.google.com/s2/favicons?sz=64&domain=gitlab.com",
  "gladly": "https://www.google.com/s2/favicons?sz=64&domain=gladly.com",
  "gorgias": "https://www.google.com/s2/favicons?sz=64&domain=gorgias.com",
  "height": "https://www.google.com/s2/favicons?sz=64&domain=height.com",
  "helpscout": "https://www.google.com/s2/favicons?sz=64&domain=helpscout.com",
  "hive": "https://www.google.com/s2/favicons?sz=64&domain=hive.com",
  "humi": "https://www.google.com/s2/favicons?sz=64&domain=humi.com",
  "kustomer": "https://www.google.com/s2/favicons?sz=64&domain=kustomer.com",
  "linear": "https://www.google.com/s2/favicons?sz=64&domain=linear.app",
  "microsoftplanner": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "monday": "https://www.google.com/s2/favicons?sz=64&domain=monday.com",
  "pivotaltracker": "https://www.google.com/s2/favicons?sz=64&domain=pivotaltracker.com",
  "reamaze": "https://www.google.com/s2/favicons?sz=64&domain=reamaze.com",
  "shortcut": "https://www.google.com/s2/favicons?sz=64&domain=shortcut.com",
  "smartsheet": "https://www.google.com/s2/favicons?sz=64&domain=smartsheet.com",
  "spotdraft": "https://www.google.com/s2/favicons?sz=64&domain=spotdraft.com",
  "teamwork": "https://www.google.com/s2/favicons?sz=64&domain=teamwork.com",
  "trello": "https://www.google.com/s2/favicons?sz=64&domain=trello.com",
  "wrike": "https://www.google.com/s2/favicons?sz=64&domain=wrike.com",
  "youtrack": "https://www.google.com/s2/favicons?sz=64&domain=youtrack.com",
  "zohobugtracker": "https://www.google.com/s2/favicons?sz=64&domain=zohobugtracker.com",
  "zohodesk": "https://www.google.com/s2/favicons?sz=64&domain=zohodesk.com",
  "zohopeople": "https://www.google.com/s2/favicons?sz=64&domain=zohopeople.com",
  "awscodecommit": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "azuredevops": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "githubonprem": "https://www.google.com/s2/favicons?sz=64&domain=github.com",
  "gitlabonprem": "https://www.google.com/s2/favicons?sz=64&domain=gitlab.com",
  "13security": "https://www.google.com/s2/favicons?sz=64&domain=13security.com",
  "aftra": "https://www.google.com/s2/favicons?sz=64&domain=aftra.com",
  "aikido": "https://www.google.com/s2/favicons?sz=64&domain=aikido.com",
  "almanax": "https://www.google.com/s2/favicons?sz=64&domain=almanax.com",
  "astrasecurity": "https://www.google.com/s2/favicons?sz=64&domain=astrasecurity.com",
  "attackerview": "https://www.google.com/s2/favicons?sz=64&domain=attackerview.com",
  "awsguardduty": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "awsinspector": "https://www.google.com/s2/favicons?sz=64&domain=aws.amazon.com",
  "azuredefender": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "blacklocksecurity": "https://www.google.com/s2/favicons?sz=64&domain=blacklocksecurity.com",
  "botprise": "https://www.google.com/s2/favicons?sz=64&domain=botprise.com",
  "breachlock": "https://www.google.com/s2/favicons?sz=64&domain=breachlockinc.com",
  "capturethebug": "https://www.google.com/s2/favicons?sz=64&domain=capturethebug.com",
  "coana": "https://www.google.com/s2/favicons?sz=64&domain=coana.com",
  "cobalt": "https://www.google.com/s2/favicons?sz=64&domain=cobalt.io",
  "coguard": "https://www.google.com/s2/favicons?sz=64&domain=coguard.com",
  "contxt": "https://www.google.com/s2/favicons?sz=64&domain=contxt.com",
  "deepsource": "https://www.google.com/s2/favicons?sz=64&domain=deepsource.com",
  "edgebit": "https://www.google.com/s2/favicons?sz=64&domain=edgebit.com",
  "fencer": "https://www.google.com/s2/favicons?sz=64&domain=fencer.com",
  "gcpcontaineranalysis": "https://www.google.com/s2/favicons?sz=64&domain=cloud.google.com",
  "githubdependabot": "https://www.google.com/s2/favicons?sz=64&domain=github.com",
  "halosecurity": "https://www.google.com/s2/favicons?sz=64&domain=halosecurity.com",
  "heyhack": "https://www.google.com/s2/favicons?sz=64&domain=heyhack.com",
  "hostedscan": "https://www.google.com/s2/favicons?sz=64&domain=hostedscan.com",
  "intruder": "https://www.google.com/s2/favicons?sz=64&domain=intruder.com",
  "jitsecurity": "https://www.google.com/s2/favicons?sz=64&domain=jit.com",
  "lacework": "https://www.google.com/s2/favicons?sz=64&domain=lacework.com",
  "lumenovaai": "https://www.google.com/s2/favicons?sz=64&domain=lumenova.com",
  "defendergcchigh": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "defenderforcloud": "https://www.google.com/s2/favicons?sz=64&domain=microsoft.com",
  "orca": "https://www.google.com/s2/favicons?sz=64&domain=orca.com",
  "ostorlab": "https://www.google.com/s2/favicons?sz=64&domain=ostorlab.com",
  "panopticscans": "https://www.google.com/s2/favicons?sz=64&domain=panopticscans.com",
  "pentesttools": "https://www.google.com/s2/favicons?sz=64&domain=pentest-tools.com",
  "plerion": "https://www.google.com/s2/favicons?sz=64&domain=plerion.com",
  "prancer": "https://www.google.com/s2/favicons?sz=64&domain=prancer.com",
  "probely": "https://www.google.com/s2/favicons?sz=64&domain=probely.com",
  "qualys": "https://www.google.com/s2/favicons?sz=64&domain=qualys.com",
  "rapid7": "https://www.google.com/s2/favicons?sz=64&domain=rapid7.com",
  "sentinelone": "https://www.google.com/s2/favicons?sz=64&domain=sentinelone.com",
  "snyk": "https://www.google.com/s2/favicons?sz=64&domain=snyk.io",
  "socket": "https://www.google.com/s2/favicons?sz=64&domain=socket.com",
  "softwaresecured": "https://www.google.com/s2/favicons?sz=64&domain=softwaresecured.com",
  "soos": "https://www.google.com/s2/favicons?sz=64&domain=soos.com",
  "stackhawk": "https://www.google.com/s2/favicons?sz=64&domain=stackhawk.com",
  "strikesecurity": "https://www.google.com/s2/favicons?sz=64&domain=strikesecurity.com",
  "tenablevulnmgmt": "https://www.google.com/s2/favicons?sz=64&domain=tenable.com",
  "threatmate": "https://www.google.com/s2/favicons?sz=64&domain=threatmate.com",
  "trava": "https://www.google.com/s2/favicons?sz=64&domain=trava.com",
  "wiz": "https://www.google.com/s2/favicons?sz=64&domain=wiz.io",
  "wizforgoverment": "https://www.google.com/s2/favicons?sz=64&domain=wiz.io",

};

/* ── Vendor metadata ─────────────────────────────────────────── */
const VENDOR_META = {
  aws:          { name: 'AWS',           accent: '#FF9900', stepLabels: [i18n.t('VendorDetailsPage.stepAccountType'), i18n.t('VendorDetailsPage.stepServices'), i18n.t('VendorDetailsPage.stepConnect')] },
  azure:        { name: 'Azure',         accent: '#0089D6', stepLabels: [i18n.t('VendorDetailsPage.stepEnvironment'),  i18n.t('VendorDetailsPage.stepServices'), i18n.t('VendorDetailsPage.stepConnect')] },
  gcp:          { name: 'GCP',           accent: '#34A853', stepLabels: [i18n.t('VendorDetailsPage.stepAccountType'), i18n.t('VendorDetailsPage.stepProducts'), i18n.t('VendorDetailsPage.stepConnect')] },
  jira:         { name: 'Jira',          accent: '#0052CC', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  kubernetes:   { name: 'Kubernetes',    accent: '#326CE5', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  digitalocean: { name: 'DigitalOcean',  accent: '#0080FF', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  cloudflare:   { name: 'Cloudflare',    vendorType: 'CLOUDFLARE', accent: '#F38020', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  sentry:       { name: 'Sentry',        vendorType: 'SENTRY', accent: '#362D59', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  gitlab:       { name: 'GitLab',        accent: '#FC6D26', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  bitbucket:    { name: 'Bitbucket',     accent: '#0052CC', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  okta:         { name: 'Okta',          accent: '#007DC1', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  googleworkspace: { name: 'Google Workspace', vendorType: 'GOOGLE_WORKSPACE', accent: '#4285F4', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  onelogin:     { name: 'OneLogin',      accent: '#1C1F2A', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  jumpcloud:    { name: 'JumpCloud',     accent: '#17A2B8', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  duo:          { name: 'Cisco Duo',     vendorType: 'DUO', accent: '#6BBE45', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  pingone:      { name: 'Ping Identity', vendorType: 'PINGONE', accent: '#B01E28', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  auth0:        { name: 'Auth0',         vendorType: 'AUTH0', accent: '#EB5424', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  clerk:        { name: 'Clerk',         vendorType: 'CLERK', accent: '#6C47FF', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  postmark:     { name: 'Postmark',      vendorType: 'POSTMARK', accent: '#FFDE00', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  jamf:         { name: 'Jamf Pro',      vendorType: 'JAMF', accent: '#3B4B5B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  intune:       { name: 'Microsoft Intune', vendorType: 'INTUNE', accent: '#0078D4', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  kandji:       { name: 'Kandji',        vendorType: 'KANDJI', accent: '#6A5CFF', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  servicenow:   { name: 'ServiceNow',    accent: '#62D84E', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  datadog:      { name: 'Datadog',       accent: '#632CA6', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  splunk:       { name: 'Splunk',        accent: '#000000', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  pagerduty:    { name: 'PagerDuty',     accent: '#06AC38', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  newrelic:     { name: 'New Relic',     accent: '#008C99', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  crowdstrike:  { name: 'CrowdStrike',   accent: '#E00000', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  slack:        { name: 'Slack',         accent: '#4A154B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  microsoft:    { name: 'Microsoft 365', accent: '#D83B01', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  snowflake:    { name: 'Snowflake',     accent: '#29B5E8', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ascend": { name: "A-SCEND", vendorType: "ASCEND", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "assurancelab": { name: "Assurance Lab", vendorType: "ASSURANCELAB", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "audora": { name: "Audora", vendorType: "AUDORA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "fieldguide": { name: "Fieldguide", vendorType: "FIELDGUIDE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "trenta": { name: "Trenta", vendorType: "TRENTA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "certn": { name: "Certn", vendorType: "CERTN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "checkr": { name: "Checkr", vendorType: "CHECKR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hirepass": { name: "HirePass", vendorType: "HIREPASS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "veremark": { name: "Veremark", vendorType: "VEREMARK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "vetty": { name: "Vetty", vendorType: "VETTY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zinc": { name: "Zinc", vendorType: "ZINC", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "capsule": { name: "Capsule", vendorType: "CAPSULE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "close": { name: "Close", vendorType: "CLOSE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "copper": { name: "Copper", vendorType: "COPPER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hubspot": { name: "HubSpot", vendorType: "HUBSPOT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "insightly": { name: "Insightly", vendorType: "INSIGHTLY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "salesforce": { name: "Salesforce", vendorType: "SALESFORCE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zendesk": { name: "Zendesk", vendorType: "ZENDESK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "amazonecr": { name: "Amazon ECR", vendorType: "AMAZONECR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "awsgovcloud": { name: "AWS GovCloud", vendorType: "AWSGOVCLOUD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "digitaloceanspaces": { name: "DigitalOcean Spaces", vendorType: "DIGITALOCEANSPACES", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gcpartifact": { name: "GCP Artifact Registry", vendorType: "GCPARTIFACT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "grafanacloud": { name: "Grafana Cloud", vendorType: "GRAFANACLOUD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "heroku": { name: "Heroku", vendorType: "HEROKU", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "netlify": { name: "Netlify", vendorType: "NETLIFY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "oci": { name: "Oracle Cloud Infrastructure (OCI)", vendorType: "OCI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ovhcloud": { name: "OVHcloud", vendorType: "OVH_CLOUD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "railway": { name: "Railway", vendorType: "RAILWAY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "render": { name: "Render", vendorType: "RENDER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "scaleway": { name: "Scaleway", vendorType: "SCALEWAY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "vercel": { name: "Vercel", vendorType: "VERCEL", accent: '#000000', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "intercom": { name: "Intercom", vendorType: "INTERCOM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zoom": { name: "Zoom", vendorType: "ZOOM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "databricks": { name: "Databricks", vendorType: "DATABRICKS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "mongoatlas": { name: "MongoDB Atlas", vendorType: "MONGOATLAS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "box": { name: "Box", vendorType: "BOX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "dropbox": { name: "Dropbox", vendorType: "DROPBOX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "googledrive": { name: "Google Drive", vendorType: "GOOGLEDRIVE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "guru": { name: "Guru", vendorType: "GURU", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "microsoftsharepoint": { name: "Microsoft Sharepoint", vendorType: "MICROSOFTSHAREPOINT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "notion": { name: "Notion", vendorType: "NOTION", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "pima": { name: "Pima", vendorType: "PIMA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "agency": { name: "Agency", vendorType: "AGENCY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "automox": { name: "Automox", vendorType: "AUTOMOX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hexnode": { name: "Hexnode", vendorType: "HEXNODE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "kitecyber": { name: "Kitecyber", vendorType: "KITECYBER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "7shifts": { name: "7shifts", vendorType: "V_7SHIFTS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "adpworkforce": { name: "ADP Workforce Now", vendorType: "ADPWORKFORCE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "alexishr": { name: "AlexisHR", vendorType: "ALEXISHR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "alterapayroll": { name: "Altera Payroll", vendorType: "ALTERAPAYROLL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "bamboohr": { name: "BambooHR", vendorType: "BAMBOOHR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "bob": { name: "Bob", vendorType: "BOB", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "breathe": { name: "Breathe", vendorType: "BREATHE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "breezyhr": { name: "Breezy HR", vendorType: "BREEZY_HR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "breezyhrx": { name: "BreezyHR", vendorType: "BREEZYHR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "central": { name: "Central", vendorType: "CENTRAL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "dayforce": { name: "Ceridian Dayforce", vendorType: "DAYFORCE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "charliehr": { name: "CharlieHR", vendorType: "CHARLIEHR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "clayhr": { name: "ClayHR", vendorType: "CLAYHR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cyberark": { name: "CyberArk", vendorType: "CYBERARK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "deel": { name: "Deel", vendorType: "DEEL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "employmenthero": { name: "Employment Hero", vendorType: "EMPLOYMENTHERO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "factorial": { name: "Factorial", vendorType: "FACTORIAL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "freshteam": { name: "Freshteam", vendorType: "FRESHTEAM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gusto": { name: "Gusto", vendorType: "GUSTO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hrcloud": { name: "HR Cloud", vendorType: "HRCLOUD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hrpartner": { name: "HR Partner", vendorType: "HRPARTNER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "humaans": { name: "Humaans", vendorType: "HUMAANS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "insperity": { name: "Insperity", vendorType: "INSPERITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "intellihr": { name: "IntelliHR", vendorType: "INTELLIHR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "isolved": { name: "ISolved", vendorType: "ISOLVED", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "justworks": { name: "Justworks", vendorType: "JUSTWORKS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "kallidus": { name: "Kallidus (Sapling)", vendorType: "KALLIDUS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "keka": { name: "Keka", vendorType: "KEKA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "kenjo": { name: "Kenjo", vendorType: "KENJO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "lano": { name: "Lano", vendorType: "LANO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "lucca": { name: "LuccaHR", vendorType: "LUCCA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "namely": { name: "Namely", vendorType: "NAMELY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "netsuite": { name: "Netsuite", vendorType: "NETSUITE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "nmbrs": { name: "Nmbrs", vendorType: "NMBRS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "officient": { name: "Officient", vendorType: "OFFICIENT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "oraclecloudhcm": { name: "Oracle Cloud HCM", vendorType: "ORACLE_CLOUD_HCM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "oyster": { name: "Oyster", vendorType: "OYSTER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "paycaptain": { name: "Paycaptain", vendorType: "PAYCAPTAIN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "paychexflex": { name: "Paychex Flex", vendorType: "PAYCHEXFLEX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "paycor": { name: "Paycor", vendorType: "PAYCOR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "payfit95f52": { name: "Payfit", vendorType: "PAYFIT_95F52", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "paylocity": { name: "Paylocity", vendorType: "PAYLOCITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "payworks": { name: "Payworks", vendorType: "PAYWORKS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "peoplehr": { name: "PeopleHR", vendorType: "PEOPLEHR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "personio": { name: "Personio", vendorType: "PERSONIO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "proliant": { name: "Proliant", vendorType: "PROLIANT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "quickbooks": { name: "QuickBooks", vendorType: "QUICKBOOKS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "remote": { name: "Remote", vendorType: "REMOTE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "rippling": { name: "Rippling", vendorType: "RIPPLING", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sage": { name: "Sage", vendorType: "SAGE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sagehr": { name: "Sage HR", vendorType: "SAGEHR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sapsuccessfactors": { name: "SAP Successfactors", vendorType: "SAPSUCCESSFACTORS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sesame": { name: "Sesame", vendorType: "SESAME", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "squarepayrollf5639": { name: "Square Payroll", vendorType: "SQUAREPAYROLL_F5639", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "torii": { name: "Torii", vendorType: "TORII", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "trinet": { name: "TriNet", vendorType: "TRINET", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ukgdimensions": { name: "UKG Dimensions", vendorType: "UKGDIMENSIONS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ukgpro": { name: "UKG Pro", vendorType: "UKGPRO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ukgready": { name: "UKG Ready", vendorType: "UKGREADY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "workable": { name: "Workable", vendorType: "WORKABLE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "workday": { name: "Workday", vendorType: "WORKDAY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zenefits": { name: "Zenefits", vendorType: "ZENEFITS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "azuread": { name: "Azure Active Directory", vendorType: "AZUREAD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "office365": { name: "Entra (Office 365)", vendorType: "OFFICE365", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "entragcchigh": { name: "Microsoft Entra (GCC High)", vendorType: "ENTRA_GCC_HIGH", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sclaeai": { name: "ScaleAI", vendorType: "SCLAEAI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "breachrx": { name: "BreachRX", vendorType: "BREACHRX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "incident": { name: "Incident.io", vendorType: "INCIDENT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "addigy": { name: "Addigy", vendorType: "ADDIGY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "datto": { name: "Datto", vendorType: "DATTO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "edamametechnologies": { name: "EDAMAME Technologies", vendorType: "EDAMAMETECHNOLOGIES", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "fleet": { name: "Fleet", vendorType: "FLEET", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "microsoftintune": { name: "Intune (Microsoft Endpoint Manager)", vendorType: "MICROSOFTINTUNE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "iru": { name: "Iru", vendorType: "IRU", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "kolide": { name: "Kolide, by 1Password", vendorType: "KOLIDE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "manageengine": { name: "Manage Engine", vendorType: "MANAGEENGINE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "microsoftendpointmanager": { name: "Microsoft Endpoint Manager", vendorType: "MICROSOFTENDPOINTMANAGER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "intunegcchigh": { name: "Microsoft Intune (GCC High)", vendorType: "INTUNE_GCC_HIGH", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "miradore": { name: "Miradore", vendorType: "MIRADORE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ninjaone": { name: "NinjaOne", vendorType: "NINJAONE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "omnissa": { name: "Omnissa Workspace One", vendorType: "OMNISSA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "primo": { name: "Primo", vendorType: "PRIMO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "simplemdm": { name: "SimpleMDM", vendorType: "SIMPLEMDM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "swif": { name: "Swif", vendorType: "SWIF", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "trio": { name: "Trio", vendorType: "TRIO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "vmwareworkspaceone": { name: "VMWare Workspace One", vendorType: "VMWAREWORKSPACEONE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "xcitium": { name: "Xcitium", vendorType: "XCITIUM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "xfa": { name: "XFA", vendorType: "XFA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cobrickobserve": { name: "co.brick observe", vendorType: "COBRICKOBSERVE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sumologic": { name: "Sumo Logic", vendorType: "SUMOLOGIC", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "1password": { name: "1Password Device Trust", vendorType: "V_1PASSWORD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "4me": { name: "4me", vendorType: "V_4ME", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "8x8": { name: "8x8", vendorType: "V_8X8", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "abv": { name: "Abv", vendorType: "ABV", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "accessowl": { name: "AccessOwl", vendorType: "ACCESSOWL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "acunetix360": { name: "Acunetix360", vendorType: "ACUNETIX360", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "adobelearning": { name: "Adobe Learning Manager", vendorType: "ADOBELEARNING", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "airtable": { name: "Airtable", vendorType: "AIRTABLE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "akamai": { name: "Akamai", vendorType: "AKAMAI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "alertmedia": { name: "Alert Media", vendorType: "ALERTMEDIA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "amplitude": { name: "Amplitude", vendorType: "AMPLITUDE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "anthropic": { name: "Anthropic", vendorType: "ANTHROPIC", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "apollo": { name: "Apollo", vendorType: "APOLLO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "appaegis76b4c": { name: "Appaegis", vendorType: "APPAEGIS_76B4C", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "applebusinessmanager": { name: "Apple Business Manager", vendorType: "APPLEBUSINESSMANAGER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "appranix": { name: "Appranix", vendorType: "APPRANIX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ashby": { name: "Ashby", vendorType: "ASHBY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "assetpanda": { name: "Asset Panda", vendorType: "ASSETPANDA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "axisatmos": { name: "Atmos", vendorType: "AXISATMOS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "autodesk": { name: "Autodesk", vendorType: "AUTODESK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "azuresynapse": { name: "Azure Synapse Analytics", vendorType: "AZURESYNAPSE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "bis": { name: "BIS", vendorType: "BIS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "bitwarden": { name: "Bitwarden", vendorType: "BITWARDEN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "blink": { name: "Blink", vendorType: "BLINK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "blinq": { name: "Blinq", vendorType: "BLINQ", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "blogin": { name: "Blogin", vendorType: "BLOGIN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "bluejeans": { name: "Bluejeans", vendorType: "BLUEJEANS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "bocada": { name: "Bocada", vendorType: "BOCADA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "brex": { name: "Brex", vendorType: "BREX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "britive": { name: "Britive", vendorType: "BRITIVE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "browserstack": { name: "BrowserStack", vendorType: "BROWSERSTACK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "calendly": { name: "Calendly", vendorType: "CALENDLY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cats": { name: "CATS", vendorType: "CATS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "charthop": { name: "ChartHop", vendorType: "CHARTHOP", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "checkproof": { name: "CheckProof", vendorType: "CHECKPROOF", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cinode": { name: "Cinode", vendorType: "CINODE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cleanmailf734a": { name: "Cleanmail", vendorType: "CLEANMAIL_F734A", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "clebex": { name: "Clebex", vendorType: "CLEBEX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "clockworkrecruiter": { name: "Clockwork Recruiting", vendorType: "CLOCKWORKRECRUITER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cloudback": { name: "Cloudback", vendorType: "CLOUDBACK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "coda": { name: "Coda", vendorType: "CODA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "comeet": { name: "Comeet", vendorType: "COMEET", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "commonpaper": { name: "Common Paper", vendorType: "COMMONPAPER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "confluence": { name: "Confluence", vendorType: "CONFLUENCE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "contentful": { name: "Contentful", vendorType: "CONTENTFUL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "continuitystrength": { name: "Continuity Strength", vendorType: "CONTINUITYSTRENGTH", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cside": { name: "cside", vendorType: "CSIDE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cybsafe": { name: "CybSafe", vendorType: "CYBSAFE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "dashlane": { name: "Dashlane", vendorType: "DASHLANE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "dbtlab": { name: "dbt Labs", vendorType: "DBTLAB", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "dockerhub": { name: "Dockerhub", vendorType: "DOCKERHUB", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "documo": { name: "Documo", vendorType: "DOCUMO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "docusign": { name: "Docusign", vendorType: "DOCUSIGN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "doppler": { name: "Doppler", vendorType: "DOPPLER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "drift": { name: "Drift", vendorType: "DRIFT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "dynatrace": { name: "Dynatrace", vendorType: "DYNATRACE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "elastic": { name: "Elastic", vendorType: "ELASTIC", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "eletive": { name: "Eletive", vendorType: "ELETIVE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "elium": { name: "elium", vendorType: "ELIUM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "envkey": { name: "EnvKey", vendorType: "ENVKEY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "envoy": { name: "Envoy", vendorType: "ENVOY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "evervault": { name: "Evervault", vendorType: "EVERVAULT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "exium": { name: "Exium", vendorType: "EXIUM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "faceup": { name: "FaceUp", vendorType: "FACEUP", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "figma": { name: "Figma", vendorType: "FIGMA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "fivetran": { name: "Fivetran", vendorType: "FIVETRAN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "flock": { name: "Flock", vendorType: "FLOCK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "foodee": { name: "Foodee", vendorType: "FOODEE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "fourfour": { name: "Four/Four", vendorType: "FOURFOUR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gdprlocal": { name: "GDPRLocal", vendorType: "GDPRLOCAL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ghostable": { name: "Ghostable", vendorType: "GHOSTABLE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gong": { name: "Gong", vendorType: "GONG", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "grammarly": { name: "Grammarly", vendorType: "GRAMMARLY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "greenhouse": { name: "Greenhouse", vendorType: "GREENHOUSE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "griffo": { name: "Griffo", vendorType: "GRIFFO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "h5mag": { name: "H5mag", vendorType: "H5MAG", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "harness": { name: "Harness", vendorType: "HARNESS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "harvest": { name: "Harvest", vendorType: "HARVEST", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "helloid": { name: "HelloID", vendorType: "HELLOID", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hootsuite": { name: "Hootsuite", vendorType: "HOOTSUITE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hoxhunt": { name: "HoxHunt", vendorType: "HOXHUNT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ideagen": { name: "Ideagen", vendorType: "IDEAGEN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ideo": { name: "Ideo", vendorType: "IDEO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "invision": { name: "InVision", vendorType: "INVISION", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "jobadder": { name: "JobAdder", vendorType: "JOBADDER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "jobvite": { name: "JobVite", vendorType: "JOBVITE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "jostle": { name: "Jostle", vendorType: "JOSTLE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "junojourney": { name: "Juno Journey", vendorType: "JUNOJOURNEY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "keeper": { name: "Keeper", vendorType: "KEEPER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "kpifire": { name: "KPI Fire", vendorType: "KPIFIRE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "lastpass": { name: "LastPass", vendorType: "LASTPASS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "lattice": { name: "Lattice", vendorType: "LATTICE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "latticeflowai": { name: "LatticeFlow AI", vendorType: "LATTICEFLOWAI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "launchdarkly": { name: "LaunchDarkly", vendorType: "LAUNCHDARKLY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "leapsome": { name: "Leapsome", vendorType: "LEAPSOME", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "lever": { name: "Lever", vendorType: "LEVER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "logicgate": { name: "LogicGate", vendorType: "LOGICGATE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "loom": { name: "Loom", vendorType: "LOOM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "looop": { name: "Looop", vendorType: "LOOOP", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "lucid": { name: "Lucid", vendorType: "LUCID", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "appaegis": { name: "Mammoth Cyber (Appaegis)", vendorType: "APPAEGIS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "maptician": { name: "Maptician", vendorType: "MAPTICIAN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "metapulse": { name: "MetaPulse", vendorType: "METAPULSE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "mindtickle": { name: "Mindtickle", vendorType: "MINDTICKLE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "miro": { name: "Miro", vendorType: "MIRO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "mixpanel": { name: "Mixpanel", vendorType: "MIXPANEL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "mode": { name: "Mode", vendorType: "MODE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "multiplier": { name: "Multiplier", vendorType: "MULTIPLIER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "mypolicies": { name: "myPolicies", vendorType: "MYPOLICIES", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "nordpass": { name: "NordPass", vendorType: "NORDPASS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "openai": { name: "OpenAI", vendorType: "OPENAI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "opsbook": { name: "OpsBook", vendorType: "OPSBOOK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "opsgenie1f68e": { name: "Opsgenie", vendorType: "OPSGENIE_1F68E", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "opslevel": { name: "OpsLevel", vendorType: "OPSLEVEL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "osano": { name: "Osano", vendorType: "OSANO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "parsable": { name: "Parsable", vendorType: "PARSABLE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "peakon": { name: "Peakon", vendorType: "PEAKON", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "peripass": { name: "Peripass", vendorType: "PERIPASS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "phalanx": { name: "Phalanx", vendorType: "PHALANX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "pipedrive": { name: "Pipedrive", vendorType: "PIPEDRIVE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "postman": { name: "Postman", vendorType: "POSTMAN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "prioritymatrix": { name: "Priority Matrix", vendorType: "PRIORITYMATRIX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "probackupbv": { name: "Pro Backup BV", vendorType: "PROBACKUPBV", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "prodpad": { name: "Prodpad", vendorType: "PRODPAD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "productboard": { name: "Productboard", vendorType: "PRODUCTBOARD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "qlik": { name: "Qlik", vendorType: "QLIK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ramp": { name: "Ramp", vendorType: "RAMP", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ravenna": { name: "Ravenna", vendorType: "RAVENNA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "reportit": { name: "Report It", vendorType: "REPORTIT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "rfpio": { name: "Responsive (RFPIO)", vendorType: "RFPIO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "retool": { name: "Retool", vendorType: "RETOOL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "robin": { name: "Robin", vendorType: "ROBIN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "rockset": { name: "Rockset", vendorType: "ROCKSET", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "rollbar": { name: "Rollbar", vendorType: "ROLLBAR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "scaleai": { name: "Scale AI", vendorType: "SCALEAI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "securily": { name: "Securily", vendorType: "SECURILY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "segment": { name: "Segment", vendorType: "SEGMENT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "shopify": { name: "Shopify", vendorType: "SHOPIFY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sigma": { name: "Sigma Computing", vendorType: "SIGMA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "simplebackups": { name: "SimpleBackups", vendorType: "SIMPLEBACKUPS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "slab": { name: "Slab", vendorType: "SLAB", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "smartfile": { name: "Smartfile", vendorType: "SMARTFILE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "smartrecruiters": { name: "SmartRecruiters", vendorType: "SMARTRECRUITERS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sophos": { name: "Sophos", vendorType: "SOPHOS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sparkhire": { name: "Sparkhire", vendorType: "SPARKHIRE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "speakupnow": { name: "SpeakUp Now", vendorType: "SPEAKUPNOW", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "splashtop": { name: "Splashtop", vendorType: "SPLASHTOP", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "statsig": { name: "Statsig", vendorType: "STATSIG", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "subrosa": { name: "Subrosa", vendorType: "SUBROSA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "supabase": { name: "Supabase", vendorType: "SUPABASE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sym": { name: "Sym", vendorType: "SYM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "tailscale": { name: "Tailscale", vendorType: "TAILSCALE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "talentech": { name: "Talentech", vendorType: "TALENTECH", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "teamtailor": { name: "Teamtailor", vendorType: "TEAMTAILOR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "termius": { name: "Termius", vendorType: "TERMIUS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "timetoreply": { name: "timetoreply", vendorType: "TIMETOREPLY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "torq": { name: "Torq", vendorType: "TORQ", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "travelperk": { name: "Travelperk", vendorType: "TRAVELPERK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "trelica": { name: "Trelica by 1Password", vendorType: "TRELICA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "tribeloo": { name: "Tribeloo", vendorType: "TRIBELOO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "twingate": { name: "Twingate", vendorType: "TWINGATE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "unifi": { name: "Unifi", vendorType: "UNIFI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "vendr": { name: "Vendr", vendorType: "VENDR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "vonage": { name: "Vonage", vendorType: "VONAGE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "webex": { name: "WebEx", vendorType: "WEBEX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "whimsical": { name: "Whimsical", vendorType: "WHIMSICAL", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "workplace": { name: "Workplace", vendorType: "WORKPLACE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "xero": { name: "Xero", vendorType: "XERO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zapier": { name: "Zapier", vendorType: "ZAPIER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zavanta": { name: "Zavanta", vendorType: "ZAVANTA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zero": { name: "Zero", vendorType: "ZERO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zip": { name: "Zip", vendorType: "ZIP", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zoominfo": { name: "ZoomInfo", vendorType: "ZOOMINFO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "360learning": { name: "360Learning", vendorType: "V_360LEARNING", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "adaptivesecurity": { name: "Adaptive Security", vendorType: "ADAPTIVESECURITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "awarego": { name: "AwareGo", vendorType: "AWAREGO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "caniphish": { name: "CanIPhish", vendorType: "CANIPHISH", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cybeready": { name: "CybeReady", vendorType: "CYBEREADY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cyberly": { name: "Cyberly", vendorType: "CYBERLY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "easyllama": { name: "EasyLlama", vendorType: "EASYLLAMA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "elba": { name: "Elba", vendorType: "ELBA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ethena": { name: "Ethena", vendorType: "ETHENA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ghosteye": { name: "GhostEye", vendorType: "GHOSTEYE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "haekka": { name: "Haekka", vendorType: "HAEKKA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hooksecurity": { name: "Hook Security", vendorType: "HOOKSECURITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "curricula": { name: "Huntress", vendorType: "CURRICULA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "kamae": { name: "Kama\u00e9", vendorType: "KAMAE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "knowbe4": { name: "KnowBe4", vendorType: "KNOWBE4", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "moxso": { name: "Moxso", vendorType: "MOXSO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ninjio": { name: "Ninjio", vendorType: "NINJIO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "outkept": { name: "Outkept", vendorType: "OUTKEPT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "outthink": { name: "OutThink", vendorType: "OUTTHINK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ransomleak": { name: "RansomLeak", vendorType: "RANSOMLEAK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "riot": { name: "Riot", vendorType: "RIOT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "safestack": { name: "SafeStack", vendorType: "SAFESTACK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "smartfense": { name: "Smartfense", vendorType: "SMARTFENSE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sosafe": { name: "SoSafe", vendorType: "SOSAFE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "succeedlearn": { name: "SucceedLEARN by Succeed Technologies", vendorType: "SUCCEEDLEARN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "talentlms": { name: "TalentLMS", vendorType: "TALENTLMS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "vansec": { name: "Vansec", vendorType: "VANSEC", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "wizer": { name: "Wizer", vendorType: "WIZER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "aha": { name: "Aha!", vendorType: "AHA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "asana": { name: "Asana", vendorType: "ASANA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "basecamp": { name: "Basecamp", vendorType: "BASECAMP", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "clickup": { name: "ClickUp", vendorType: "CLICKUP", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "dixa": { name: "Dixa", vendorType: "DIXA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "freshdesk": { name: "Freshdesk", vendorType: "FRESHDESK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "freshservice": { name: "freshservice", vendorType: "FRESHSERVICE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "front": { name: "Front", vendorType: "FRONT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "githubissues": { name: "Github Issues", vendorType: "GITHUBISSUES", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gitlabissues": { name: "GitLab Issues", vendorType: "GITLABISSUES", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gitlabissuesonprem": { name: "GitLab Issues (On-Prem)", vendorType: "GITLABISSUESONPREM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gladly": { name: "Gladly", vendorType: "GLADLY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gorgias": { name: "Gorgias", vendorType: "GORGIAS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "height": { name: "Height", vendorType: "HEIGHT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "helpscout": { name: "Help Scout", vendorType: "HELPSCOUT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hive": { name: "Hive", vendorType: "HIVE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "humi": { name: "Humi", vendorType: "HUMI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "kustomer": { name: "Kustomer", vendorType: "KUSTOMER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "linear": { name: "Linear", vendorType: "LINEAR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "microsoftplanner": { name: "Microsoft Planner", vendorType: "MICROSOFTPLANNER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "monday": { name: "Monday", vendorType: "MONDAY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "pivotaltracker": { name: "Pivotal Tracker", vendorType: "PIVOTALTRACKER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "reamaze": { name: "Re:amaze", vendorType: "REAMAZE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "shortcut": { name: "Shortcut", vendorType: "SHORTCUT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "smartsheet": { name: "Smartsheet", vendorType: "SMARTSHEET", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "spotdraft": { name: "Spotdraft", vendorType: "SPOTDRAFT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "taskp3": { name: "TaskP3 by Raidon, Inc", vendorType: "TASKP3", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "teamwork": { name: "Teamwork", vendorType: "TEAMWORK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "trello": { name: "Trello", vendorType: "TRELLO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "wrike": { name: "Wrike", vendorType: "WRIKE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "youtrack": { name: "YouTrack", vendorType: "YOUTRACK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zohobugtracker": { name: "Zoho BugTracker", vendorType: "ZOHOBUGTRACKER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zohodesk": { name: "Zoho Desk", vendorType: "ZOHODESK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "zohopeople": { name: "Zoho People", vendorType: "ZOHOPEOPLE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "awscodecommit": { name: "AWS CodeCommit", vendorType: "AWSCODECOMMIT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "azuredevops": { name: "Azure DevOps", vendorType: "AZUREDEVOPS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "githubonprem": { name: "GitHub On-Prem", vendorType: "GITHUBONPREM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gitlabonprem": { name: "GitLab (On-Prem)", vendorType: "GITLABONPREM", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "13security": { name: "13 Security", vendorType: "V_13SECURITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "aftra": { name: "Aftra", vendorType: "AFTRA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "aikido": { name: "Aikido", vendorType: "AIKIDO", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "almanax": { name: "Almanax", vendorType: "ALMANAX", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "astrasecurity": { name: "Astra Security", vendorType: "ASTRASECURITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "attackerview": { name: "Attackerview", vendorType: "ATTACKERVIEW", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "awsguardduty": { name: "AWS GuardDuty", vendorType: "AWSGUARDDUTY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "awsinspector": { name: "AWS Inspector", vendorType: "AWSINSPECTOR", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "azuredefender": { name: "Azure Defender", vendorType: "AZUREDEFENDER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "blacklocksecurity": { name: "Blacklock Security", vendorType: "BLACKLOCKSECURITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "botprise": { name: "Botprise", vendorType: "BOTPRISE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "breachlock": { name: "BreachLock Inc.", vendorType: "BREACHLOCK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cacilian": { name: "Cacilian LLC- A Prescient Security Company", vendorType: "CACILIAN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "capturethebug": { name: "Capture the Bug", vendorType: "CAPTURETHEBUG", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "coana": { name: "Coana", vendorType: "COANA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "cobalt": { name: "Cobalt Labs", vendorType: "COBALT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "coguard": { name: "Coguard", vendorType: "COGUARD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "contxt": { name: "Contxt", vendorType: "CONTXT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "deepsource": { name: "DeepSource", vendorType: "DEEPSOURCE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "edgebit": { name: "EdgeBit", vendorType: "EDGEBIT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "fencer": { name: "Fencer", vendorType: "FENCER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "gcpcontaineranalysis": { name: "GCP Container Analysis", vendorType: "GCPCONTAINERANALYSIS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "githubdependabot": { name: "Github Dependabot", vendorType: "GITHUBDEPENDABOT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "halosecurity": { name: "Halo Security", vendorType: "HALOSECURITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "heyhack": { name: "HeyHack", vendorType: "HEYHACK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "hostedscan": { name: "HostedScan", vendorType: "HOSTEDSCAN", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "intruder": { name: "Intruder", vendorType: "INTRUDER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "jitsecurity": { name: "Jit", vendorType: "JITSECURITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "lacework": { name: "Lacework", vendorType: "LACEWORK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "lumenovaai": { name: "Lumenova", vendorType: "LUMENOVAAI", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "defendergcchigh": { name: "Microsoft Defender (GCC High)", vendorType: "DEFENDER_GCC_HIGH", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "defenderforcloud": { name: "Microsoft Defender for Cloud", vendorType: "DEFENDERFORCLOUD", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "orca": { name: "Orca", vendorType: "ORCA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "ostorlab": { name: "Ostorlab", vendorType: "OSTORLAB", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "panopticscans": { name: "Panoptic Scans", vendorType: "PANOPTICSCANS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "pentesttools": { name: "Pentest-Tools.com", vendorType: "PENTESTTOOLS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "plerion": { name: "Plerion", vendorType: "PLERION", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "prancer": { name: "Prancer", vendorType: "PRANCER", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "probely": { name: "Probely", vendorType: "PROBELY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "qualys": { name: "Qualys", vendorType: "QUALYS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "rapid7": { name: "Rapid7", vendorType: "RAPID7", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "sentinelone": { name: "SentinelOne", vendorType: "SENTINELONE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "snyk": { name: "Snyk", vendorType: "SNYK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "socket": { name: "Socket", vendorType: "SOCKET", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "softwaresecured": { name: "Software Secured", vendorType: "SOFTWARESECURED", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "soos": { name: "SOOS", vendorType: "SOOS", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "stackhawk": { name: "StackHawk", vendorType: "STACKHAWK", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "strikesecurity": { name: "Strike Security", vendorType: "STRIKESECURITY", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "tenablevulnmgmt": { name: "Tenable Vulnerability Management", vendorType: "TENABLEVULNMGMT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "threatmate": { name: "Threatmate", vendorType: "THREATMATE", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "trava": { name: "Trava", vendorType: "TRAVA", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "wiz": { name: "Wiz", vendorType: "WIZ", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
  "wizforgoverment": { name: "Wiz for Goverment", vendorType: "WIZ_FOR_GOVERMENT", accent: '#64748B', stepLabels: [i18n.t('VendorDetailsPage.stepConnect')] },
};

/* ── AWS / Azure / GCP service lists ───────────────────────── */
const AWS_SERVICES = [
  { id: 'EC2 Instances',     icon: 'fa-server',      desc: i18n.t('VendorDetailsPage.awsEc2Desc') },
  { id: 'S3 Buckets',        icon: 'fa-database',    desc: i18n.t('VendorDetailsPage.awsS3Desc') },
  { id: 'Lambda',            icon: 'fa-bolt',        desc: i18n.t('VendorDetailsPage.awsLambdaDesc') },
  { id: 'RDS',               icon: 'fa-th-list',     desc: i18n.t('VendorDetailsPage.awsRdsDesc') },
  { id: 'IAM Users & Roles', icon: 'fa-user-shield', desc: i18n.t('VendorDetailsPage.awsIamDesc') },
];

const AZURE_SERVICES = [
  { id: 'Virtual Machines',       icon: 'fa-desktop',  desc: i18n.t('VendorDetailsPage.azureVmDesc') },
  { id: 'Blob Storage',           icon: 'fa-archive',  desc: i18n.t('VendorDetailsPage.azureBlobDesc') },
  { id: 'Azure Active Directory', icon: 'fa-id-badge', desc: i18n.t('VendorDetailsPage.azureAdDesc') },
  { id: 'Azure Functions',        icon: 'fa-bolt',     desc: i18n.t('VendorDetailsPage.azureFunctionsDesc') },
];

const GCP_PRODUCTS = [
  { id: 'Compute Engine', icon: 'fa-server',      desc: i18n.t('VendorDetailsPage.gcpComputeDesc') },
  { id: 'Cloud Storage',  icon: 'fa-archive',     desc: i18n.t('VendorDetailsPage.gcpStorageDesc') },
  { id: 'IAM & Admin',    icon: 'fa-user-shield', desc: i18n.t('VendorDetailsPage.gcpIamDesc') },
  { id: 'Cloud Functions',icon: 'fa-bolt',        desc: i18n.t('VendorDetailsPage.gcpFunctionsDesc') },
];

/* ── Config-driven simple vendor flows ──────────────────────── */
const VENDOR_FLOWS = {
  kubernetes: {
    title: i18n.t('VendorDetailsPage.kubernetesTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.kubernetesHeading'),
      steps: [
        <>Create a service account in your cluster:<br /><code>kubectl create serviceaccount cataam-reader -n kube-system</code></>,
        <>Bind the built-in <strong>view</strong> ClusterRole:<br /><code>kubectl create clusterrolebinding cataam-reader --clusterrole=view --serviceaccount=kube-system:cataam-reader</code></>,
        <>Generate a token:<br /><code>kubectl create token cataam-reader -n kube-system --duration=8760h</code></>,
        <>Find your API server URL:<br /><code>kubectl cluster-info | grep "control plane"</code></>,
      ],
    },
    fields: [
      { key: 'apiServer',   label: i18n.t('VendorDetailsPage.clusterApiUrlLabel'),        type: 'text',     placeholder: 'https://api.my-cluster.example.com:6443' },
      { key: 'bearerToken', label: i18n.t('VendorDetailsPage.serviceAccountTokenLabel'),  type: 'password', placeholder: 'eyJhbGciOiJSUzI1NiIsInR5...' },
      { key: 'namespace',   label: i18n.t('VendorDetailsPage.namespaceLabel'),            type: 'text',     placeholder: 'default' },
    ],
    isValid: (c) => !!(c.apiServer && c.bearerToken),
  },

  gitlab: {
    title: i18n.t('VendorDetailsPage.gitlabTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.gitlabHeading'),
      steps: [
        <>Go to <strong>GitLab → User Settings → Access Tokens</strong> (or use a Group/Project token for scoped access).</>,
        <>Click <strong>Add new token</strong>, name it <code>CATAAM</code>.</>,
        <>Select scopes: <code>read_api</code>, <code>read_user</code>, <code>read_repository</code>.</>,
        <>Click <strong>Create personal access token</strong> and copy the value.</>,
        <>Your GitLab URL is typically <code>https://gitlab.com</code> or your self-hosted instance domain.</>,
      ],
    },
    fields: [
      { key: 'gitlabUrl',   label: i18n.t('VendorDetailsPage.gitlabUrlLabel'), type: 'text',     placeholder: 'https://gitlab.com' },
      { key: 'accessToken', label: i18n.t('VendorDetailsPage.personalAccessTokenLabel'), type: 'password', placeholder: 'glpat-xxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!(c.gitlabUrl && c.accessToken),
  },

  bitbucket: {
    title: i18n.t('VendorDetailsPage.bitbucketTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.bitbucketHeading'),
      steps: [
        <>Go to <strong>Bitbucket → Your account → Personal settings → App passwords</strong>.</>,
        <>Click <strong>Create app password</strong>, name it <code>CATAAM</code>.</>,
        <>Grant permissions: <strong>Repositories: Read</strong>, <strong>Projects: Read</strong>, <strong>Workspace membership: Read</strong>.</>,
        <>Copy the app password (shown only once).</>,
        <>Your workspace slug is the short name in your Bitbucket URL: <code>bitbucket.org/&#123;workspace-slug&#125;/</code></>,
      ],
    },
    fields: [
      { key: 'username',      label: i18n.t('VendorDetailsPage.bitbucketUsernameLabel'),  type: 'text',     placeholder: 'your-bitbucket-username' },
      { key: 'appPassword',   label: i18n.t('VendorDetailsPage.appPasswordLabel'),        type: 'password', placeholder: 'ATBB...' },
      { key: 'workspace',     label: i18n.t('VendorDetailsPage.workspaceSlugLabel'),      type: 'text',     placeholder: 'my-workspace' },
    ],
    isValid: (c) => !!(c.username && c.appPassword && c.workspace),
  },

  digitalocean: {
    title: 'Connect DigitalOcean',
    instructions: {
      heading: 'Create a read-only DigitalOcean API token',
      steps: [
        <>Log into the <strong>DigitalOcean Control Panel</strong>.</>,
        <>Go to <strong>API → Tokens → Generate New Token</strong>.</>,
        <>Name it <code>CATAAM</code> and grant <strong>Read</strong> scope only.</>,
        <>Click <strong>Generate Token</strong> and copy the value (shown only once).</>,
      ],
    },
    fields: [
      { key: 'apiToken', label: 'API Token', type: 'password', placeholder: 'dop_v1_xxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!c.apiToken,
  },

  cloudflare: {
    title: 'Connect Cloudflare',
    instructions: {
      heading: 'Create a scoped Cloudflare API token',
      steps: [
        <>Log into the <strong>Cloudflare dashboard</strong> and go to <strong>My Profile → API Tokens</strong>.</>,
        <>Click <strong>Create Token → Create Custom Token</strong>, name it <code>CATAAM</code>.</>,
        <>Grant <strong>Zone → Zone → Read</strong> and <strong>Zone → SSL and Certificates → Read</strong> for <strong>All zones</strong>.</>,
        <>Click <strong>Continue to summary → Create Token</strong> and copy the value (shown only once).</>,
      ],
    },
    fields: [
      { key: 'apiToken', label: 'API Token', type: 'password', placeholder: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!c.apiToken,
  },

  sentry: {
    title: 'Connect Sentry',
    instructions: {
      heading: 'Create a Sentry auth token',
      steps: [
        <>In Sentry go to <strong>Settings → Account → API → Auth Tokens</strong>.</>,
        <>Click <strong>Create New Token</strong>, name it <code>CATAAM</code>.</>,
        <>Grant the <code>org:read</code> and <code>project:read</code> scopes and copy the token.</>,
        <>Your organization slug is in the URL: <code>sentry.io/organizations/&#123;org-slug&#125;/</code>.</>,
      ],
    },
    fields: [
      { key: 'authToken', label: 'Auth Token',        type: 'password', placeholder: 'sntrys_xxxxxxxxxxxxxxxxxxxx' },
      { key: 'orgSlug',   label: 'Organization Slug',  type: 'text',     placeholder: 'my-org' },
    ],
    isValid: (c) => !!(c.authToken && c.orgSlug),
  },

  okta: {
    title: i18n.t('VendorDetailsPage.oktaTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.oktaHeading'),
      steps: [
        <>Log into the <strong>Okta Admin Console</strong>.</>,
        <>Go to <strong>Security → API → Tokens → Create Token</strong>.</>,
        <>Name the token <code>CATAAM</code> and click <strong>Create Token</strong>.</>,
        <>Copy the token value immediately — it won't be shown again.</>,
        <>Your Okta domain is the full subdomain of your instance, e.g. <code>yourcompany.okta.com</code>.</>,
      ],
    },
    fields: [
      { key: 'oktaDomain',  label: i18n.t('VendorDetailsPage.oktaDomainLabel'),  type: 'text',     placeholder: 'yourcompany.okta.com' },
      { key: 'apiToken',    label: i18n.t('VendorDetailsPage.apiTokenLabel'),     type: 'password', placeholder: '00xxxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!(c.oktaDomain && c.apiToken),
  },

  onelogin: {
    title: 'Connect OneLogin',
    instructions: {
      heading: 'Create a read-only OneLogin API credential',
      steps: [
        <>Log into the <strong>OneLogin Admin</strong> portal.</>,
        <>Go to <strong>Developers → API Credentials → New Credential</strong> and grant <strong>Read</strong> scope.</>,
        <>Copy the <strong>Client ID</strong> and <strong>Client Secret</strong>, and note your subdomain (e.g. <code>acme</code> for acme.onelogin.com).</>,
      ],
    },
    fields: [
      { key: 'subdomain',    label: 'Subdomain',     type: 'text',     placeholder: 'acme' },
      { key: 'clientId',     label: 'Client ID',     type: 'text',     placeholder: 'xxxxxxxx' },
      { key: 'clientSecret', label: 'Client Secret', type: 'password', placeholder: 'xxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!(c.subdomain && c.clientId && c.clientSecret),
  },

  jumpcloud: {
    title: 'Connect JumpCloud',
    instructions: {
      heading: 'Create a read-only JumpCloud API key',
      steps: [
        <>Log into the <strong>JumpCloud Admin Console</strong>.</>,
        <>Go to <strong>Settings → API</strong> and generate an <strong>API key</strong> (bound to a read-only admin).</>,
        <>Copy the key and paste it below — CATAAM only reads users, groups and MFA config.</>,
      ],
    },
    fields: [
      { key: 'apiKey', label: 'API key', type: 'password', placeholder: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!c.apiKey,
  },

  duo: {
    title: 'Connect Cisco Duo',
    instructions: {
      heading: 'Create a read-only Duo Admin API integration',
      steps: [
        <>In the <strong>Duo Admin Panel</strong>, go to <strong>Applications → Protect an Application</strong> and protect <strong>Admin API</strong>.</>,
        <>Grant it the <strong>Grant read resource</strong> permission only.</>,
        <>Copy the <strong>integration key</strong>, <strong>secret key</strong> and <strong>API hostname</strong> and paste them below — CATAAM only reads users and groups.</>,
      ],
    },
    fields: [
      { key: 'apiHostname',    label: 'API hostname',    type: 'text',     placeholder: 'api-xxxxxxxx.duosecurity.com' },
      { key: 'integrationKey', label: 'Integration key', type: 'text',     placeholder: 'DIxxxxxxxxxxxxxxxxxx' },
      { key: 'secretKey',      label: 'Secret key',      type: 'password', placeholder: '••••••••••••••••••••••••••••••••' },
    ],
    isValid: (c) => !!(c.apiHostname && c.integrationKey && c.secretKey),
  },

  pingone: {
    title: 'Connect Ping Identity (PingOne)',
    instructions: {
      heading: 'Create a read-only PingOne Worker application',
      steps: [
        <>In the <strong>PingOne console</strong>, go to <strong>Connections → Applications</strong> and add a <strong>Worker</strong> application.</>,
        <>Grant it read-only roles (Identity Data Read Only) and copy its <strong>Client ID</strong> and <strong>Client Secret</strong>.</>,
        <>Copy your <strong>Environment ID</strong> from the environment overview and select your PingOne region below — CATAAM only reads users and groups.</>,
      ],
    },
    fields: [
      { key: 'environmentId', label: 'Environment ID', type: 'text',     placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'clientId',      label: 'Client ID',      type: 'text',     placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'clientSecret',  label: 'Client secret',  type: 'password', placeholder: '••••••••••••••••••••••••' },
      { key: 'region',        label: 'Region',         type: 'select',   options: ['na', 'eu', 'ca', 'asia', 'au'], defaultValue: 'na' },
    ],
    isValid: (c) => !!(c.environmentId && c.clientId && c.clientSecret),
  },

  auth0: {
    title: 'Connect Auth0',
    instructions: {
      heading: 'Create a read-only Auth0 Machine-to-Machine application',
      steps: [
        <>In the <strong>Auth0 dashboard</strong>, go to <strong>Applications</strong> and create a <strong>Machine to Machine</strong> app authorized for the <strong>Auth0 Management API</strong>.</>,
        <>Grant it only the <code>read:users</code> and <code>read:roles</code> scopes and copy its <strong>Client ID</strong> and <strong>Client Secret</strong>.</>,
        <>Enter your Auth0 <strong>domain</strong> (e.g. <code>acme.us.auth0.com</code>) and those credentials below — CATAAM only reads users and roles.</>,
      ],
    },
    fields: [
      { key: 'domain',       label: 'Auth0 domain',  type: 'text',     placeholder: 'acme.us.auth0.com' },
      { key: 'clientId',     label: 'Client ID',     type: 'text',     placeholder: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
      { key: 'clientSecret', label: 'Client secret', type: 'password', placeholder: '••••••••••••••••••••••••••••••••' },
    ],
    isValid: (c) => !!(c.domain && c.clientId && c.clientSecret),
  },

  clerk: {
    title: 'Connect Clerk',
    instructions: {
      heading: 'Copy a Clerk Backend API secret key',
      steps: [
        <>In the <strong>Clerk Dashboard</strong>, go to <strong>API Keys</strong>.</>,
        <>Copy the <strong>Secret Key</strong> (starts with <code>sk_live_</code> for a production instance, <code>sk_test_</code> for development).</>,
        <>Enter it below — CATAAM only reads users and organizations.</>,
      ],
    },
    fields: [
      { key: 'secretKey', label: 'Secret Key', type: 'password', placeholder: 'sk_live_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!c.secretKey,
  },

  postmark: {
    title: 'Connect Postmark',
    instructions: {
      heading: 'Copy a Postmark Account API token',
      steps: [
        <>In your <strong>Postmark account</strong> (not a single server), go to <strong>Account API Tokens</strong>.</>,
        <>Copy the <strong>Account API token</strong> — a server/sending token cannot read domain verification status, only the account-level token can.</>,
        <>Enter it below — CATAAM only reads sending-domain verification status (DKIM, Return-Path, SPF).</>,
      ],
    },
    fields: [
      { key: 'accountToken', label: 'Account API Token', type: 'password', placeholder: '••••••••••••••••••••••••••••••••••••' },
    ],
    isValid: (c) => !!c.accountToken,
  },

  jamf: {
    title: 'Connect Jamf Pro',
    instructions: {
      heading: 'Create a read-only Jamf Pro API client',
      steps: [
        <>In <strong>Jamf Pro</strong>, go to <strong>Settings → API Roles and Clients</strong> and create an <strong>API Role</strong> with read-only privileges (Read Computers, Read Computer Inventory Collection).</>,
        <>Create an <strong>API Client</strong> bound to that role and copy its <strong>Client ID</strong> and <strong>Client Secret</strong>.</>,
        <>Enter your Jamf URL (e.g. <code>https://acme.jamfcloud.com</code>) and those credentials below — CATAAM only reads device inventory.</>,
      ],
    },
    fields: [
      { key: 'baseUrl',      label: 'Jamf URL',      type: 'text',     placeholder: 'https://acme.jamfcloud.com' },
      { key: 'clientId',     label: 'Client ID',     type: 'text',     placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'clientSecret', label: 'Client secret', type: 'password', placeholder: '••••••••••••••••••••••••••••••••' },
    ],
    isValid: (c) => !!(c.baseUrl && c.clientId && c.clientSecret),
  },

  intune: {
    title: 'Connect Microsoft Intune',
    instructions: {
      heading: 'Register a read-only Entra ID application for Microsoft Graph',
      steps: [
        <>In <strong>Microsoft Entra ID → App registrations</strong>, register an application.</>,
        <>Under <strong>API permissions</strong>, add the Microsoft Graph application permission <code>DeviceManagementManagedDevices.Read.All</code> and grant admin consent.</>,
        <>Create a <strong>client secret</strong>, then enter the tenant ID, client ID and secret below — CATAAM only reads managed-device inventory.</>,
      ],
    },
    fields: [
      { key: 'tenantId',     label: 'Tenant ID',     type: 'text',     placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'clientId',     label: 'Client ID',     type: 'text',     placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'clientSecret', label: 'Client secret', type: 'password', placeholder: '••••••••••••••••••••••••••••••••' },
    ],
    isValid: (c) => !!(c.tenantId && c.clientId && c.clientSecret),
  },

  kandji: {
    title: 'Connect Kandji',
    instructions: {
      heading: 'Create a read-only Kandji API token',
      steps: [
        <>In <strong>Kandji</strong>, go to <strong>Settings → Access → API Token</strong> and add an API token with read-only device permissions.</>,
        <>Note your <strong>API URL</strong> (e.g. <code>https://acme.api.kandji.io</code>) shown next to the token.</>,
        <>Enter the API URL and token below — CATAAM only reads device inventory.</>,
      ],
    },
    fields: [
      { key: 'apiUrl',   label: 'API URL',   type: 'text',     placeholder: 'https://acme.api.kandji.io' },
      { key: 'apiToken', label: 'API token', type: 'password', placeholder: '••••••••-••••-••••-••••-••••••••••••' },
    ],
    isValid: (c) => !!(c.apiUrl && c.apiToken),
  },

  servicenow: {
    title: i18n.t('VendorDetailsPage.servicenowTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.servicenowHeading'),
      steps: [
        <>Log into your ServiceNow instance as an admin.</>,
        <>Go to <strong>User Administration → Users → New</strong>. Create a user (e.g., <code>cataam_integration</code>).</>,
        <>Assign the <code>itil</code> and <code>cmdb_read</code> roles to the user.</>,
        <>Set a password and note the username.</>,
        <>Your instance URL is the base domain of your ServiceNow environment, e.g. <code>yourcompany.service-now.com</code>.</>,
      ],
    },
    fields: [
      { key: 'instanceUrl', label: i18n.t('VendorDetailsPage.instanceUrlLabel'),  type: 'text',     placeholder: 'yourcompany.service-now.com' },
      { key: 'username',    label: i18n.t('VendorDetailsPage.usernameLabel'),       type: 'text',     placeholder: 'cataam_integration' },
      { key: 'password',    label: i18n.t('VendorDetailsPage.passwordLabel'),       type: 'password', placeholder: '••••••••' },
    ],
    isValid: (c) => !!(c.instanceUrl && c.username && c.password),
  },

  datadog: {
    title: i18n.t('VendorDetailsPage.datadogTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.datadogHeading'),
      steps: [
        <>Go to <strong>Datadog → Organization Settings → API Keys → New Key</strong>. Name it <code>CATAAM</code> and copy the <strong>API Key</strong>.</>,
        <>Go to <strong>Organization Settings → Application Keys → New Key</strong>. Name it <code>CATAAM</code> and copy the <strong>Application Key</strong>.</>,
        <>Both keys are required — the API Key identifies your org; the Application Key scopes permissions.</>,
      ],
    },
    fields: [
      { key: 'apiKey', label: i18n.t('VendorDetailsPage.apiKeyLabel'),         type: 'password', placeholder: 'ddxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
      { key: 'appKey', label: i18n.t('VendorDetailsPage.applicationKeyLabel'), type: 'password', placeholder: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
      { key: 'ddSite', label: 'Datadog site', type: 'select',
        options: ['datadoghq.com', 'us3.datadoghq.com', 'us5.datadoghq.com', 'datadoghq.eu', 'ap1.datadoghq.com'],
        defaultValue: 'datadoghq.com' },
    ],
    isValid: (c) => !!(c.apiKey && c.appKey),
  },

  splunk: {
    title: i18n.t('VendorDetailsPage.splunkTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.splunkHeading'),
      steps: [
        <>Log into <strong>Splunk Web</strong> as an admin.</>,
        <>Go to <strong>Settings → Tokens → New Token</strong> (Splunk Enterprise 8.0+ / Splunk Cloud).</>,
        <>Set an audience of <code>CATAAM</code>, optionally set an expiry, then click <strong>Create</strong>.</>,
        <>Copy the token value.</>,
        <>Your instance URL is the base URL you use to access Splunk, e.g. <code>https://splunk.yourcompany.com:8089</code>.</>,
      ],
    },
    fields: [
      { key: 'instanceUrl', label: i18n.t('VendorDetailsPage.splunkInstanceUrlLabel'), type: 'text',     placeholder: 'https://splunk.yourcompany.com:8089' },
      { key: 'apiToken',    label: i18n.t('VendorDetailsPage.apiTokenLabel'),            type: 'password', placeholder: 'Splunk xxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!(c.instanceUrl && c.apiToken),
  },

  pagerduty: {
    title: i18n.t('VendorDetailsPage.pagerdutyTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.pagerdutyHeading'),
      steps: [
        <>Go to <strong>PagerDuty → Integrations → API Access Keys</strong> (requires Account Owner or Admin role).</>,
        <>Click <strong>Create New API Key</strong>, name it <code>CATAAM</code>.</>,
        <>Select <strong>Read-only API Key</strong> — CATAAM only reads data.</>,
        <>Copy the key value (shown only once).</>,
      ],
    },
    fields: [
      { key: 'apiKey', label: i18n.t('VendorDetailsPage.apiKeyLabel'), type: 'password', placeholder: 'u+xxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!(c.apiKey),
  },

  newrelic: {
    title: i18n.t('VendorDetailsPage.newrelicTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.newrelicHeading'),
      steps: [
        <>Go to <strong>New Relic → User menu (bottom-left) → API keys</strong>.</>,
        <>Click <strong>Create a key</strong>, select type <strong>User</strong>, name it <code>CATAAM</code>.</>,
        <>Click <strong>Create a key</strong> and copy the value.</>,
        <>Your Account ID is visible in the browser URL when logged in: <code>one.newrelic.com/accounts/&#123;ACCOUNT_ID&#125;</code>.</>,
      ],
    },
    fields: [
      { key: 'accountId', label: i18n.t('VendorDetailsPage.accountIdLabel'),    type: 'text',     placeholder: '1234567' },
      { key: 'apiKey',    label: i18n.t('VendorDetailsPage.userApiKeyLabel'),   type: 'password', placeholder: 'NRAK-xxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!(c.accountId && c.apiKey),
  },

  crowdstrike: {
    title: i18n.t('VendorDetailsPage.crowdstrikeTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.crowdstrikeHeading'),
      steps: [
        <>Log into the <strong>Falcon Console</strong> and go to <strong>Support &amp; Resources → API Clients and Keys</strong>.</>,
        <>Click <strong>Add new API client</strong>, name it <code>CATAAM</code>.</>,
        <>Select these scopes: <strong>Devices: Read</strong>, <strong>Detections: Read</strong>, <strong>Incidents: Read</strong>, <strong>Prevention Policies: Read</strong>.</>,
        <>Click <strong>Add</strong> and copy the <strong>Client ID</strong> and <strong>Client Secret</strong>.</>,
        <>Your cloud region is shown in the Falcon console URL — e.g. <code>US-1</code> for <code>falcon.crowdstrike.com</code>.</>,
      ],
    },
    fields: [
      { key: 'clientId',     label: i18n.t('VendorDetailsPage.clientIdLabel'),      type: 'text',     placeholder: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
      { key: 'clientSecret', label: i18n.t('VendorDetailsPage.clientSecretLabel'),   type: 'password', placeholder: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' },
      { key: 'cloudRegion',  label: i18n.t('VendorDetailsPage.cloudRegionLabel'),    type: 'text',     placeholder: 'US-1  (or US-2, EU-1, US-GOV-1)' },
    ],
    isValid: (c) => !!(c.clientId && c.clientSecret && c.cloudRegion),
  },

  slack: {
    title: i18n.t('VendorDetailsPage.slackTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.slackHeading'),
      steps: [
        <>Go to <a href="https://api.slack.com/apps" target="_blank" rel="noopener noreferrer">api.slack.com/apps</a> and click <strong>Create New App → From scratch</strong>.</>,
        <>Name it <code>CATAAM</code> and select your workspace.</>,
        <>Go to <strong>OAuth &amp; Permissions → Scopes → Bot Token Scopes</strong> and add:<br /><code>channels:read</code>, <code>groups:read</code>, <code>users:read</code>, <code>team:read</code>, <code>apps:read</code></>,
        <>Click <strong>Install to Workspace</strong>, approve the permissions.</>,
        <>Copy the <strong>Bot User OAuth Token</strong> (starts with <code>xoxb-</code>).</>,
      ],
    },
    fields: [
      { key: 'botToken', label: i18n.t('VendorDetailsPage.botTokenLabel'), type: 'password', placeholder: 'xoxb-xxxxxxxxxxxx-xxxxxxxxxxxx-xxxxxxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!(c.botToken),
  },

  microsoft: {
    title: i18n.t('VendorDetailsPage.microsoftTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.microsoftHeading'),
      steps: [
        <>Go to <a href="https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationsListBlade" target="_blank" rel="noopener noreferrer">Azure Portal → Microsoft Entra ID → App registrations</a> and click <strong>New registration</strong>.</>,
        <>Name it <code>CATAAM M365</code>, accept defaults, click <strong>Register</strong>.</>,
        <>Copy the <strong>Application (client) ID</strong> and the <strong>Directory (tenant) ID</strong> from the Overview page.</>,
        <>Go to <strong>Certificates &amp; secrets → New client secret</strong>, set expiry, click <strong>Add</strong>, and copy the <strong>Value</strong>.</>,
        <>Go to <strong>API permissions → Add a permission → Microsoft Graph → Application permissions</strong>. Add: <code>User.Read.All</code>, <code>Group.Read.All</code>, <code>Directory.Read.All</code>, <code>Sites.Read.All</code>.</>,
        <>Click <strong>Grant admin consent for [your org]</strong>.</>,
      ],
    },
    fields: [
      { key: 'tenantId',     label: i18n.t('VendorDetailsPage.tenantIdLabel'),              type: 'text',     placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'clientId',     label: i18n.t('VendorDetailsPage.applicationClientIdLabel'), type: 'text',     placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'clientSecret', label: i18n.t('VendorDetailsPage.clientSecretValueLabel'),    type: 'password', placeholder: i18n.t('VendorDetailsPage.enterClientSecretPlaceholder') },
    ],
    isValid: (c) => !!(c.tenantId && c.clientId && c.clientSecret),
  },

  snowflake: {
    title: i18n.t('VendorDetailsPage.snowflakeTitle'),
    instructions: {
      heading: i18n.t('VendorDetailsPage.snowflakeHeading'),
      steps: [
        <>Log into Snowflake as <code>SYSADMIN</code> or <code>ACCOUNTADMIN</code> and run:</>,
        <>
          <code>CREATE ROLE cataam_reader;</code><br />
          <code>GRANT USAGE ON DATABASE &lt;your_db&gt; TO ROLE cataam_reader;</code><br />
          <code>GRANT USAGE ON ALL SCHEMAS IN DATABASE &lt;your_db&gt; TO ROLE cataam_reader;</code><br />
          <code>GRANT SELECT ON ALL TABLES IN DATABASE &lt;your_db&gt; TO ROLE cataam_reader;</code>
        </>,
        <>
          Generate an RSA key pair (Snowflake does not support password login for the SQL API):<br />
          <code>openssl genrsa 2048 | openssl pkcs8 -topk8 -inform PEM -out cataam_key.p8 -nocrypt</code><br />
          <code>openssl rsa -in cataam_key.p8 -pubout -out cataam_key.pub</code>
        </>,
        <>
          Create the service user with the PUBLIC key:<br />
          <code>CREATE USER cataam_reader DEFAULT_ROLE=cataam_reader RSA_PUBLIC_KEY='&lt;contents of cataam_key.pub&gt;';</code><br />
          <code>GRANT ROLE cataam_reader TO USER cataam_reader;</code>
        </>,
        <>Paste the <strong>private key</strong> (<code>cataam_key.p8</code>) below. Your account identifier is in the console URL: <code>&lt;account-identifier&gt;.snowflakecomputing.com</code>.</>,
      ],
    },
    fields: [
      { key: 'account',    label: i18n.t('VendorDetailsPage.snowflakeAccountUrlLabel'), type: 'text',     placeholder: 'myaccount  (or myaccount.snowflakecomputing.com)' },
      { key: 'username',   label: i18n.t('VendorDetailsPage.usernameLabel'),            type: 'text',     placeholder: 'CATAAM_READER' },
      { key: 'privateKey', label: 'Private Key (PKCS#8 PEM)',                           type: 'textarea', placeholder: '-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----' },
    ],
    isValid: (c) => !!(c.account && c.username && c.privateKey),
  },
  "ascend": {
    title: "Connect A-SCEND",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in A-SCEND (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "assurancelab": {
    title: "Connect Assurance Lab",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Assurance Lab (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "audora": {
    title: "Connect Audora",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Audora (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "fieldguide": {
    title: "Connect Fieldguide",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Fieldguide (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "trenta": {
    title: "Connect Trenta",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Trenta (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "certn": {
    title: "Connect Certn",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Certn (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "checkr": {
    title: "Connect Checkr",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Checkr (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hirepass": {
    title: "Connect HirePass",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in HirePass (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "veremark": {
    title: "Connect Veremark",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Veremark (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "vetty": {
    title: "Connect Vetty",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Vetty (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zinc": {
    title: "Connect Zinc",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zinc (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "capsule": {
    title: "Connect Capsule",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Capsule (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "close": {
    title: "Connect Close",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Close (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "copper": {
    title: "Connect Copper",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Copper (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hubspot": {
    title: "Connect HubSpot",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in HubSpot (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "insightly": {
    title: "Connect Insightly",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Insightly (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "salesforce": {
    title: "Connect Salesforce",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Salesforce (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zendesk": {
    title: "Connect Zendesk",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zendesk (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "amazonecr": {
    title: "Connect Amazon ECR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Amazon ECR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "awsgovcloud": {
    title: "Connect AWS GovCloud",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in AWS GovCloud (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "digitaloceanspaces": {
    title: "Connect DigitalOcean Spaces",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in DigitalOcean Spaces (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gcpartifact": {
    title: "Connect GCP Artifact Registry",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in GCP Artifact Registry (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "grafanacloud": {
    title: "Connect Grafana Cloud",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Grafana Cloud (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "heroku": {
    title: "Connect Heroku",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Heroku (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "netlify": {
    title: "Connect Netlify",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Netlify (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "oci": {
    title: "Connect Oracle Cloud Infrastructure (OCI)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Oracle Cloud Infrastructure (OCI) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ovhcloud": {
    title: "Connect OVHcloud",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in OVHcloud (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "railway": {
    title: "Connect Railway",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Railway (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "render": {
    title: "Connect Render",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Render (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "scaleway": {
    title: "Connect Scaleway",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Scaleway (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "vercel": {
    title: "Connect Vercel",
    instructions: {
      heading: 'Create a read-only Vercel token',
      steps: [
        <>Go to <strong>Account Settings → Tokens → Create Token</strong> (a read-only scope is enough).</>,
        <>If your projects live under a <strong>Team</strong>, also copy the <strong>Team ID</strong> from Team Settings → General — otherwise leave it blank.</>,
        <>Paste the token (and Team ID, if applicable) below — CATAAM only reads projects and settings, never deploys or changes anything.</>,
      ],
    },
    fields: [
      { key: 'apiToken', label: 'API Token', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' },
      { key: 'teamId',   label: 'Team ID (optional)', type: 'text', placeholder: 'team_xxxxxxxxxxxxxxxxxxxxxxxx' },
    ],
    isValid: (c) => !!c.apiToken,
  },
  "intercom": {
    title: "Connect Intercom",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Intercom (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zoom": {
    title: "Connect Zoom",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zoom (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "databricks": {
    title: "Connect Databricks",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Databricks (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "mongoatlas": {
    title: "Connect MongoDB Atlas",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in MongoDB Atlas (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "box": {
    title: "Connect Box",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Box (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "dropbox": {
    title: "Connect Dropbox",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Dropbox (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "googledrive": {
    title: "Connect Google Drive",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Google Drive (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "guru": {
    title: "Connect Guru",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Guru (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "microsoftsharepoint": {
    title: "Connect Microsoft Sharepoint",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Microsoft Sharepoint (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "notion": {
    title: "Connect Notion",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Notion (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "pima": {
    title: "Connect Pima",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Pima (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "agency": {
    title: "Connect Agency",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Agency (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "automox": {
    title: "Connect Automox",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Automox (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hexnode": {
    title: "Connect Hexnode",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Hexnode (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "kitecyber": {
    title: "Connect Kitecyber",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Kitecyber (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "7shifts": {
    title: "Connect 7shifts",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in 7shifts (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "adpworkforce": {
    title: "Connect ADP Workforce Now",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in ADP Workforce Now (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "alexishr": {
    title: "Connect AlexisHR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in AlexisHR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "alterapayroll": {
    title: "Connect Altera Payroll",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Altera Payroll (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "bamboohr": {
    title: "Connect BambooHR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in BambooHR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "bob": {
    title: "Connect Bob",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Bob (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "breathe": {
    title: "Connect Breathe",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Breathe (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "breezyhr": {
    title: "Connect Breezy HR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Breezy HR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "breezyhrx": {
    title: "Connect BreezyHR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in BreezyHR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "central": {
    title: "Connect Central",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Central (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "dayforce": {
    title: "Connect Ceridian Dayforce",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ceridian Dayforce (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "charliehr": {
    title: "Connect CharlieHR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in CharlieHR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "clayhr": {
    title: "Connect ClayHR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in ClayHR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cyberark": {
    title: "Connect CyberArk",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in CyberArk (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "deel": {
    title: "Connect Deel",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Deel (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "employmenthero": {
    title: "Connect Employment Hero",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Employment Hero (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "factorial": {
    title: "Connect Factorial",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Factorial (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "freshteam": {
    title: "Connect Freshteam",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Freshteam (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gusto": {
    title: "Connect Gusto",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Gusto (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hrcloud": {
    title: "Connect HR Cloud",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in HR Cloud (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hrpartner": {
    title: "Connect HR Partner",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in HR Partner (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "humaans": {
    title: "Connect Humaans",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Humaans (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "insperity": {
    title: "Connect Insperity",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Insperity (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "intellihr": {
    title: "Connect IntelliHR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in IntelliHR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "isolved": {
    title: "Connect ISolved",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in ISolved (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "justworks": {
    title: "Connect Justworks",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Justworks (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "kallidus": {
    title: "Connect Kallidus (Sapling)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Kallidus (Sapling) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "keka": {
    title: "Connect Keka",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Keka (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "kenjo": {
    title: "Connect Kenjo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Kenjo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "lano": {
    title: "Connect Lano",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Lano (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "lucca": {
    title: "Connect LuccaHR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in LuccaHR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "namely": {
    title: "Connect Namely",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Namely (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "netsuite": {
    title: "Connect Netsuite",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Netsuite (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "nmbrs": {
    title: "Connect Nmbrs",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Nmbrs (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "officient": {
    title: "Connect Officient",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Officient (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "oraclecloudhcm": {
    title: "Connect Oracle Cloud HCM",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Oracle Cloud HCM (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "oyster": {
    title: "Connect Oyster",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Oyster (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "paycaptain": {
    title: "Connect Paycaptain",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Paycaptain (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "paychexflex": {
    title: "Connect Paychex Flex",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Paychex Flex (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "paycor": {
    title: "Connect Paycor",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Paycor (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "payfit95f52": {
    title: "Connect Payfit",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Payfit (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "paylocity": {
    title: "Connect Paylocity",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Paylocity (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "payworks": {
    title: "Connect Payworks",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Payworks (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "peoplehr": {
    title: "Connect PeopleHR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in PeopleHR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "personio": {
    title: "Connect Personio",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Personio (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "proliant": {
    title: "Connect Proliant",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Proliant (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "quickbooks": {
    title: "Connect QuickBooks",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in QuickBooks (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "remote": {
    title: "Connect Remote",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Remote (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "rippling": {
    title: "Connect Rippling",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Rippling (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sage": {
    title: "Connect Sage",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Sage (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sagehr": {
    title: "Connect Sage HR",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Sage HR (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sapsuccessfactors": {
    title: "Connect SAP Successfactors",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SAP Successfactors (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sesame": {
    title: "Connect Sesame",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Sesame (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "squarepayrollf5639": {
    title: "Connect Square Payroll",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Square Payroll (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "torii": {
    title: "Connect Torii",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Torii (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "trinet": {
    title: "Connect TriNet",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in TriNet (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ukgdimensions": {
    title: "Connect UKG Dimensions",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in UKG Dimensions (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ukgpro": {
    title: "Connect UKG Pro",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in UKG Pro (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ukgready": {
    title: "Connect UKG Ready",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in UKG Ready (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "workable": {
    title: "Connect Workable",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Workable (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "workday": {
    title: "Connect Workday",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Workday (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zenefits": {
    title: "Connect Zenefits",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zenefits (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "azuread": {
    title: "Connect Azure Active Directory",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Azure Active Directory (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "office365": {
    title: "Connect Entra (Office 365)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Entra (Office 365) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "entragcchigh": {
    title: "Connect Microsoft Entra (GCC High)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Microsoft Entra (GCC High) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sclaeai": {
    title: "Connect ScaleAI",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in ScaleAI (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "breachrx": {
    title: "Connect BreachRX",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in BreachRX (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "incident": {
    title: "Connect Incident.io",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Incident.io (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "addigy": {
    title: "Connect Addigy",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Addigy (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "datto": {
    title: "Connect Datto",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Datto (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "edamametechnologies": {
    title: "Connect EDAMAME Technologies",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in EDAMAME Technologies (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "fleet": {
    title: "Connect Fleet",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Fleet (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "microsoftintune": {
    title: "Connect Intune (Microsoft Endpoint Manager)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Intune (Microsoft Endpoint Manager) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "iru": {
    title: "Connect Iru",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Iru (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "kolide": {
    title: "Connect Kolide, by 1Password",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Kolide, by 1Password (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "manageengine": {
    title: "Connect Manage Engine",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Manage Engine (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "microsoftendpointmanager": {
    title: "Connect Microsoft Endpoint Manager",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Microsoft Endpoint Manager (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "intunegcchigh": {
    title: "Connect Microsoft Intune (GCC High)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Microsoft Intune (GCC High) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "miradore": {
    title: "Connect Miradore",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Miradore (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ninjaone": {
    title: "Connect NinjaOne",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in NinjaOne (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "omnissa": {
    title: "Connect Omnissa Workspace One",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Omnissa Workspace One (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "primo": {
    title: "Connect Primo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Primo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "simplemdm": {
    title: "Connect SimpleMDM",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SimpleMDM (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "swif": {
    title: "Connect Swif",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Swif (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "trio": {
    title: "Connect Trio",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Trio (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "vmwareworkspaceone": {
    title: "Connect VMWare Workspace One",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in VMWare Workspace One (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "xcitium": {
    title: "Connect Xcitium",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Xcitium (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "xfa": {
    title: "Connect XFA",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in XFA (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cobrickobserve": {
    title: "Connect co.brick observe",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in co.brick observe (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sumologic": {
    title: "Connect Sumo Logic",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Sumo Logic (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "1password": {
    title: "Connect 1Password Device Trust",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in 1Password Device Trust (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "4me": {
    title: "Connect 4me",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in 4me (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "8x8": {
    title: "Connect 8x8",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in 8x8 (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "abv": {
    title: "Connect Abv",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Abv (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "accessowl": {
    title: "Connect AccessOwl",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in AccessOwl (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "acunetix360": {
    title: "Connect Acunetix360",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Acunetix360 (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "adobelearning": {
    title: "Connect Adobe Learning Manager",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Adobe Learning Manager (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "airtable": {
    title: "Connect Airtable",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Airtable (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "akamai": {
    title: "Connect Akamai",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Akamai (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "alertmedia": {
    title: "Connect Alert Media",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Alert Media (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "amplitude": {
    title: "Connect Amplitude",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Amplitude (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "anthropic": {
    title: "Connect Anthropic",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Anthropic (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "apollo": {
    title: "Connect Apollo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Apollo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "appaegis76b4c": {
    title: "Connect Appaegis",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Appaegis (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "applebusinessmanager": {
    title: "Connect Apple Business Manager",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Apple Business Manager (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "appranix": {
    title: "Connect Appranix",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Appranix (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ashby": {
    title: "Connect Ashby",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ashby (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "assetpanda": {
    title: "Connect Asset Panda",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Asset Panda (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "axisatmos": {
    title: "Connect Atmos",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Atmos (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "autodesk": {
    title: "Connect Autodesk",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Autodesk (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "azuresynapse": {
    title: "Connect Azure Synapse Analytics",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Azure Synapse Analytics (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "bis": {
    title: "Connect BIS",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in BIS (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "bitwarden": {
    title: "Connect Bitwarden",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Bitwarden (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "blink": {
    title: "Connect Blink",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Blink (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "blinq": {
    title: "Connect Blinq",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Blinq (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "blogin": {
    title: "Connect Blogin",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Blogin (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "bluejeans": {
    title: "Connect Bluejeans",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Bluejeans (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "bocada": {
    title: "Connect Bocada",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Bocada (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "brex": {
    title: "Connect Brex",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Brex (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "britive": {
    title: "Connect Britive",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Britive (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "browserstack": {
    title: "Connect BrowserStack",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in BrowserStack (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "calendly": {
    title: "Connect Calendly",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Calendly (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cats": {
    title: "Connect CATS",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in CATS (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "charthop": {
    title: "Connect ChartHop",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in ChartHop (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "checkproof": {
    title: "Connect CheckProof",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in CheckProof (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cinode": {
    title: "Connect Cinode",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Cinode (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cleanmailf734a": {
    title: "Connect Cleanmail",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Cleanmail (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "clebex": {
    title: "Connect Clebex",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Clebex (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "clockworkrecruiter": {
    title: "Connect Clockwork Recruiting",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Clockwork Recruiting (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cloudback": {
    title: "Connect Cloudback",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Cloudback (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "coda": {
    title: "Connect Coda",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Coda (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "comeet": {
    title: "Connect Comeet",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Comeet (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "commonpaper": {
    title: "Connect Common Paper",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Common Paper (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "confluence": {
    title: "Connect Confluence",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Confluence (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "contentful": {
    title: "Connect Contentful",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Contentful (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "continuitystrength": {
    title: "Connect Continuity Strength",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Continuity Strength (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cside": {
    title: "Connect cside",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in cside (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cybsafe": {
    title: "Connect CybSafe",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in CybSafe (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "dashlane": {
    title: "Connect Dashlane",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Dashlane (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "dbtlab": {
    title: "Connect dbt Labs",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in dbt Labs (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "dockerhub": {
    title: "Connect Dockerhub",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Dockerhub (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "documo": {
    title: "Connect Documo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Documo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "docusign": {
    title: "Connect Docusign",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Docusign (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "doppler": {
    title: "Connect Doppler",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Doppler (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "drift": {
    title: "Connect Drift",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Drift (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "dynatrace": {
    title: "Connect Dynatrace",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Dynatrace (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "elastic": {
    title: "Connect Elastic",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Elastic (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "eletive": {
    title: "Connect Eletive",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Eletive (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "elium": {
    title: "Connect elium",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in elium (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "envkey": {
    title: "Connect EnvKey",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in EnvKey (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "envoy": {
    title: "Connect Envoy",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Envoy (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "evervault": {
    title: "Connect Evervault",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Evervault (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "exium": {
    title: "Connect Exium",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Exium (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "faceup": {
    title: "Connect FaceUp",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in FaceUp (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "figma": {
    title: "Connect Figma",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Figma (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "fivetran": {
    title: "Connect Fivetran",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Fivetran (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "flock": {
    title: "Connect Flock",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Flock (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "foodee": {
    title: "Connect Foodee",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Foodee (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "fourfour": {
    title: "Connect Four/Four",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Four/Four (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gdprlocal": {
    title: "Connect GDPRLocal",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in GDPRLocal (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ghostable": {
    title: "Connect Ghostable",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ghostable (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gong": {
    title: "Connect Gong",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Gong (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "grammarly": {
    title: "Connect Grammarly",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Grammarly (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "greenhouse": {
    title: "Connect Greenhouse",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Greenhouse (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "griffo": {
    title: "Connect Griffo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Griffo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "h5mag": {
    title: "Connect H5mag",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in H5mag (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "harness": {
    title: "Connect Harness",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Harness (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "harvest": {
    title: "Connect Harvest",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Harvest (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "helloid": {
    title: "Connect HelloID",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in HelloID (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hootsuite": {
    title: "Connect Hootsuite",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Hootsuite (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hoxhunt": {
    title: "Connect HoxHunt",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in HoxHunt (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ideagen": {
    title: "Connect Ideagen",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ideagen (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ideo": {
    title: "Connect Ideo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ideo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "invision": {
    title: "Connect InVision",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in InVision (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "jobadder": {
    title: "Connect JobAdder",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in JobAdder (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "jobvite": {
    title: "Connect JobVite",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in JobVite (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "jostle": {
    title: "Connect Jostle",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Jostle (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "junojourney": {
    title: "Connect Juno Journey",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Juno Journey (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "keeper": {
    title: "Connect Keeper",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Keeper (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "kpifire": {
    title: "Connect KPI Fire",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in KPI Fire (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "lastpass": {
    title: "Connect LastPass",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in LastPass (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "lattice": {
    title: "Connect Lattice",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Lattice (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "latticeflowai": {
    title: "Connect LatticeFlow AI",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in LatticeFlow AI (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "launchdarkly": {
    title: "Connect LaunchDarkly",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in LaunchDarkly (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "leapsome": {
    title: "Connect Leapsome",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Leapsome (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "lever": {
    title: "Connect Lever",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Lever (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "logicgate": {
    title: "Connect LogicGate",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in LogicGate (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "loom": {
    title: "Connect Loom",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Loom (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "looop": {
    title: "Connect Looop",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Looop (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "lucid": {
    title: "Connect Lucid",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Lucid (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "appaegis": {
    title: "Connect Mammoth Cyber (Appaegis)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Mammoth Cyber (Appaegis) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "maptician": {
    title: "Connect Maptician",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Maptician (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "metapulse": {
    title: "Connect MetaPulse",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in MetaPulse (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "mindtickle": {
    title: "Connect Mindtickle",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Mindtickle (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "miro": {
    title: "Connect Miro",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Miro (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "mixpanel": {
    title: "Connect Mixpanel",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Mixpanel (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "mode": {
    title: "Connect Mode",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Mode (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "multiplier": {
    title: "Connect Multiplier",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Multiplier (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "mypolicies": {
    title: "Connect myPolicies",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in myPolicies (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "nordpass": {
    title: "Connect NordPass",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in NordPass (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "openai": {
    title: "Connect OpenAI",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in OpenAI (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "opsbook": {
    title: "Connect OpsBook",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in OpsBook (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "opsgenie1f68e": {
    title: "Connect Opsgenie",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Opsgenie (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "opslevel": {
    title: "Connect OpsLevel",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in OpsLevel (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "osano": {
    title: "Connect Osano",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Osano (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "parsable": {
    title: "Connect Parsable",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Parsable (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "peakon": {
    title: "Connect Peakon",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Peakon (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "peripass": {
    title: "Connect Peripass",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Peripass (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "phalanx": {
    title: "Connect Phalanx",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Phalanx (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "pipedrive": {
    title: "Connect Pipedrive",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Pipedrive (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "postman": {
    title: "Connect Postman",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Postman (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "prioritymatrix": {
    title: "Connect Priority Matrix",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Priority Matrix (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "probackupbv": {
    title: "Connect Pro Backup BV",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Pro Backup BV (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "prodpad": {
    title: "Connect Prodpad",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Prodpad (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "productboard": {
    title: "Connect Productboard",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Productboard (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "qlik": {
    title: "Connect Qlik",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Qlik (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ramp": {
    title: "Connect Ramp",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ramp (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ravenna": {
    title: "Connect Ravenna",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ravenna (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "reportit": {
    title: "Connect Report It",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Report It (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "rfpio": {
    title: "Connect Responsive (RFPIO)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Responsive (RFPIO) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "retool": {
    title: "Connect Retool",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Retool (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "robin": {
    title: "Connect Robin",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Robin (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "rockset": {
    title: "Connect Rockset",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Rockset (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "rollbar": {
    title: "Connect Rollbar",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Rollbar (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "scaleai": {
    title: "Connect Scale AI",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Scale AI (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "securily": {
    title: "Connect Securily",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Securily (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "segment": {
    title: "Connect Segment",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Segment (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "shopify": {
    title: "Connect Shopify",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Shopify (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sigma": {
    title: "Connect Sigma Computing",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Sigma Computing (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "simplebackups": {
    title: "Connect SimpleBackups",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SimpleBackups (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "slab": {
    title: "Connect Slab",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Slab (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "smartfile": {
    title: "Connect Smartfile",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Smartfile (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "smartrecruiters": {
    title: "Connect SmartRecruiters",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SmartRecruiters (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sophos": {
    title: "Connect Sophos",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Sophos (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sparkhire": {
    title: "Connect Sparkhire",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Sparkhire (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "speakupnow": {
    title: "Connect SpeakUp Now",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SpeakUp Now (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "splashtop": {
    title: "Connect Splashtop",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Splashtop (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "statsig": {
    title: "Connect Statsig",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Statsig (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "subrosa": {
    title: "Connect Subrosa",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Subrosa (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "supabase": {
    title: "Connect Supabase",
    instructions: { heading: 'Create a Supabase Management API token', steps: [
      <>Sign in to the Supabase dashboard, open your account menu (top-right avatar) and go to <strong>Account Preferences &rarr; Access Tokens</strong> (<code>supabase.com/dashboard/account/tokens</code>).</>,
      <>Click <strong>Generate new token</strong>, name it e.g. <code>CATAAM</code>, and generate it.</>,
      <>Copy the token &mdash; it starts with <code>sbp_</code> and is shown only once &mdash; then paste it below.</>,
      <>CATAAM uses it only to read configuration metadata via the Management API (projects, SSL enforcement, network restrictions, backups, members) &mdash; never your table data. A read-only OAuth connect is coming soon.</>,
    ] },
    fields: [ { key: 'apiToken', label: 'Management API access token', type: 'password', placeholder: 'sbp_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' } ],
    isValid: (c) => !!c.apiToken,
  },
  "sym": {
    title: "Connect Sym",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Sym (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "tailscale": {
    title: "Connect Tailscale",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Tailscale (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "talentech": {
    title: "Connect Talentech",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Talentech (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "teamtailor": {
    title: "Connect Teamtailor",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Teamtailor (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "termius": {
    title: "Connect Termius",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Termius (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "timetoreply": {
    title: "Connect timetoreply",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in timetoreply (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "torq": {
    title: "Connect Torq",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Torq (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "travelperk": {
    title: "Connect Travelperk",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Travelperk (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "trelica": {
    title: "Connect Trelica by 1Password",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Trelica by 1Password (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "tribeloo": {
    title: "Connect Tribeloo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Tribeloo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "twingate": {
    title: "Connect Twingate",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Twingate (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "unifi": {
    title: "Connect Unifi",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Unifi (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "vendr": {
    title: "Connect Vendr",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Vendr (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "vonage": {
    title: "Connect Vonage",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Vonage (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "webex": {
    title: "Connect WebEx",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in WebEx (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "whimsical": {
    title: "Connect Whimsical",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Whimsical (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "workplace": {
    title: "Connect Workplace",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Workplace (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "xero": {
    title: "Connect Xero",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Xero (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zapier": {
    title: "Connect Zapier",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zapier (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zavanta": {
    title: "Connect Zavanta",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zavanta (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zero": {
    title: "Connect Zero",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zero (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zip": {
    title: "Connect Zip",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zip (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zoominfo": {
    title: "Connect ZoomInfo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in ZoomInfo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "360learning": {
    title: "Connect 360Learning",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in 360Learning (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "adaptivesecurity": {
    title: "Connect Adaptive Security",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Adaptive Security (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "awarego": {
    title: "Connect AwareGo",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in AwareGo (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "caniphish": {
    title: "Connect CanIPhish",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in CanIPhish (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cybeready": {
    title: "Connect CybeReady",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in CybeReady (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cyberly": {
    title: "Connect Cyberly",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Cyberly (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "easyllama": {
    title: "Connect EasyLlama",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in EasyLlama (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "elba": {
    title: "Connect Elba",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Elba (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ethena": {
    title: "Connect Ethena",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ethena (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ghosteye": {
    title: "Connect GhostEye",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in GhostEye (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "haekka": {
    title: "Connect Haekka",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Haekka (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hooksecurity": {
    title: "Connect Hook Security",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Hook Security (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "curricula": {
    title: "Connect Huntress",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Huntress (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "kamae": {
    title: "Connect Kama\u00e9",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Kama\u00e9 (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "knowbe4": {
    title: "Connect KnowBe4",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in KnowBe4 (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "moxso": {
    title: "Connect Moxso",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Moxso (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ninjio": {
    title: "Connect Ninjio",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ninjio (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "outkept": {
    title: "Connect Outkept",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Outkept (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "outthink": {
    title: "Connect OutThink",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in OutThink (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ransomleak": {
    title: "Connect RansomLeak",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in RansomLeak (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "riot": {
    title: "Connect Riot",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Riot (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "safestack": {
    title: "Connect SafeStack",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SafeStack (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "smartfense": {
    title: "Connect Smartfense",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Smartfense (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sosafe": {
    title: "Connect SoSafe",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SoSafe (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "succeedlearn": {
    title: "Connect SucceedLEARN by Succeed Technologies",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SucceedLEARN by Succeed Technologies (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "talentlms": {
    title: "Connect TalentLMS",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in TalentLMS (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "vansec": {
    title: "Connect Vansec",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Vansec (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "wizer": {
    title: "Connect Wizer",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Wizer (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "aha": {
    title: "Connect Aha!",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Aha! (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "asana": {
    title: "Connect Asana",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Asana (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "basecamp": {
    title: "Connect Basecamp",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Basecamp (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "clickup": {
    title: "Connect ClickUp",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in ClickUp (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "dixa": {
    title: "Connect Dixa",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Dixa (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "freshdesk": {
    title: "Connect Freshdesk",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Freshdesk (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "freshservice": {
    title: "Connect freshservice",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in freshservice (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "front": {
    title: "Connect Front",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Front (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "githubissues": {
    title: "Connect Github Issues",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Github Issues (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gitlabissues": {
    title: "Connect GitLab Issues",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in GitLab Issues (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gitlabissuesonprem": {
    title: "Connect GitLab Issues (On-Prem)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in GitLab Issues (On-Prem) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gladly": {
    title: "Connect Gladly",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Gladly (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gorgias": {
    title: "Connect Gorgias",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Gorgias (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "height": {
    title: "Connect Height",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Height (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "helpscout": {
    title: "Connect Help Scout",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Help Scout (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hive": {
    title: "Connect Hive",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Hive (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "humi": {
    title: "Connect Humi",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Humi (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "kustomer": {
    title: "Connect Kustomer",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Kustomer (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "linear": {
    title: "Connect Linear",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Linear (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "microsoftplanner": {
    title: "Connect Microsoft Planner",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Microsoft Planner (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "monday": {
    title: "Connect Monday",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Monday (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "pivotaltracker": {
    title: "Connect Pivotal Tracker",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Pivotal Tracker (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "reamaze": {
    title: "Connect Re:amaze",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Re:amaze (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "shortcut": {
    title: "Connect Shortcut",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Shortcut (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "smartsheet": {
    title: "Connect Smartsheet",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Smartsheet (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "spotdraft": {
    title: "Connect Spotdraft",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Spotdraft (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "taskp3": {
    title: "Connect TaskP3 by Raidon, Inc",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in TaskP3 by Raidon, Inc (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "teamwork": {
    title: "Connect Teamwork",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Teamwork (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "trello": {
    title: "Connect Trello",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Trello (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "wrike": {
    title: "Connect Wrike",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Wrike (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "youtrack": {
    title: "Connect YouTrack",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in YouTrack (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zohobugtracker": {
    title: "Connect Zoho BugTracker",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zoho BugTracker (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zohodesk": {
    title: "Connect Zoho Desk",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zoho Desk (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "zohopeople": {
    title: "Connect Zoho People",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Zoho People (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "awscodecommit": {
    title: "Connect AWS CodeCommit",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in AWS CodeCommit (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "azuredevops": {
    title: "Connect Azure DevOps",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Azure DevOps (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "githubonprem": {
    title: "Connect GitHub On-Prem",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in GitHub On-Prem (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gitlabonprem": {
    title: "Connect GitLab (On-Prem)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in GitLab (On-Prem) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "13security": {
    title: "Connect 13 Security",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in 13 Security (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "aftra": {
    title: "Connect Aftra",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Aftra (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "aikido": {
    title: "Connect Aikido",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Aikido (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "almanax": {
    title: "Connect Almanax",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Almanax (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "astrasecurity": {
    title: "Connect Astra Security",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Astra Security (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "attackerview": {
    title: "Connect Attackerview",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Attackerview (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "awsguardduty": {
    title: "Connect AWS GuardDuty",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in AWS GuardDuty (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "awsinspector": {
    title: "Connect AWS Inspector",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in AWS Inspector (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "azuredefender": {
    title: "Connect Azure Defender",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Azure Defender (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "blacklocksecurity": {
    title: "Connect Blacklock Security",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Blacklock Security (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "botprise": {
    title: "Connect Botprise",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Botprise (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "breachlock": {
    title: "Connect BreachLock Inc.",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in BreachLock Inc. (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cacilian": {
    title: "Connect Cacilian LLC- A Prescient Security Company",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Cacilian LLC- A Prescient Security Company (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "capturethebug": {
    title: "Connect Capture the Bug",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Capture the Bug (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "coana": {
    title: "Connect Coana",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Coana (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "cobalt": {
    title: "Connect Cobalt Labs",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Cobalt Labs (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "coguard": {
    title: "Connect Coguard",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Coguard (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "contxt": {
    title: "Connect Contxt",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Contxt (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "deepsource": {
    title: "Connect DeepSource",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in DeepSource (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "edgebit": {
    title: "Connect EdgeBit",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in EdgeBit (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "fencer": {
    title: "Connect Fencer",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Fencer (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "gcpcontaineranalysis": {
    title: "Connect GCP Container Analysis",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in GCP Container Analysis (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "githubdependabot": {
    title: "Connect Github Dependabot",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Github Dependabot (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "halosecurity": {
    title: "Connect Halo Security",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Halo Security (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "heyhack": {
    title: "Connect HeyHack",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in HeyHack (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "hostedscan": {
    title: "Connect HostedScan",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in HostedScan (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "intruder": {
    title: "Connect Intruder",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Intruder (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "jitsecurity": {
    title: "Connect Jit",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Jit (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "lacework": {
    title: "Connect Lacework",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Lacework (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "lumenovaai": {
    title: "Connect Lumenova",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Lumenova (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "defendergcchigh": {
    title: "Connect Microsoft Defender (GCC High)",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Microsoft Defender (GCC High) (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "defenderforcloud": {
    title: "Connect Microsoft Defender for Cloud",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Microsoft Defender for Cloud (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "orca": {
    title: "Connect Orca",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Orca (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "ostorlab": {
    title: "Connect Ostorlab",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Ostorlab (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "panopticscans": {
    title: "Connect Panoptic Scans",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Panoptic Scans (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "pentesttools": {
    title: "Connect Pentest-Tools.com",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Pentest-Tools.com (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "plerion": {
    title: "Connect Plerion",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Plerion (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "prancer": {
    title: "Connect Prancer",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Prancer (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "probely": {
    title: "Connect Probely",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Probely (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "qualys": {
    title: "Connect Qualys",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Qualys (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "rapid7": {
    title: "Connect Rapid7",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Rapid7 (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "sentinelone": {
    title: "Connect SentinelOne",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SentinelOne (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "snyk": {
    title: "Connect Snyk",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Snyk (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "socket": {
    title: "Connect Socket",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Socket (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "softwaresecured": {
    title: "Connect Software Secured",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Software Secured (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "soos": {
    title: "Connect SOOS",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in SOOS (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "stackhawk": {
    title: "Connect StackHawk",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in StackHawk (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "strikesecurity": {
    title: "Connect Strike Security",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Strike Security (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "tenablevulnmgmt": {
    title: "Connect Tenable Vulnerability Management",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Tenable Vulnerability Management (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "threatmate": {
    title: "Connect Threatmate",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Threatmate (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "trava": {
    title: "Connect Trava",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Trava (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "wiz": {
    title: "Connect Wiz",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Wiz (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
  "wizforgoverment": {
    title: "Connect Wiz for Goverment",
    instructions: { heading: 'Create a read-only API key', steps: [
      "Create a read-only API key or token in Wiz for Goverment (a viewer / read-only role).",
      'Paste it below — CATAAM reads configuration metadata only, never your data.',
    ] },
    fields: [ { key: 'apiKey', label: 'API Key', type: 'password', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' } ],
    isValid: (c) => !!c.apiKey,
  },
};

/* ── Stepper ─────────────────────────────────────────────────── */
function Stepper({ steps, current }) {
  return (
    <div className="vd-stepper">
      {steps.map((label, i) => (
        <React.Fragment key={label}>
          <div className={`vd-step ${i < current ? 'done' : i === current ? 'active' : ''}`}>
            <div className="vd-step-dot">
              {i < current ? <i className="fas fa-check" /> : i + 1}
            </div>
            <span className="vd-step-label">{label}</span>
          </div>
          {i < steps.length - 1 && (
            <div className={`vd-step-line${i < current ? ' done' : ''}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

/* ── Service / product picker ────────────────────────────────── */
function ServicePicker({ services, selected, onToggle }) {
  return (
    <div className="vd-service-grid">
      {services.map(s => (
        <button
          key={s.id}
          className={`vd-service-card${selected.includes(s.id) ? ' vd-service-selected' : ''}`}
          onClick={() => onToggle(s.id)}
          type="button"
        >
          <div className="vd-service-check">
            {selected.includes(s.id) && <i className="fas fa-check" />}
          </div>
          <i className={`fas ${s.icon} vd-service-icon`} />
          <div className="vd-service-name">{s.id}</div>
          <div className="vd-service-desc">{s.desc}</div>
        </button>
      ))}
    </div>
  );
}

/* ── Account / environment type picker ──────────────────────── */
function TypePicker({ options, selected, onSelect }) {
  return (
    <div className="vd-type-grid">
      {options.map(opt => (
        <button
          key={opt.value}
          className={`vd-type-card${selected === opt.value ? ' vd-type-selected' : ''}`}
          onClick={() => onSelect(opt.value)}
          type="button"
        >
          <i className={`fas ${opt.icon} vd-type-icon`} />
          <div className="vd-type-name">{opt.label}</div>
          <div className="vd-type-desc">{opt.desc}</div>
          {opt.features && (
            <ul className="vd-type-features">
              {opt.features.map(f => <li key={f}>{f}</li>)}
            </ul>
          )}
        </button>
      ))}
    </div>
  );
}

/* ── Info callout ────────────────────────────────────────────── */
function InfoBox({ title, children }) {
  return (
    <div className="vd-info-box">
      <div className="vd-info-title"><i className="fas fa-info-circle" /> {title}</div>
      {children}
    </div>
  );
}

/* ── Main component ──────────────────────────────────────────── */
function VendorDetailsPage() {
  const { t } = useTranslation();
  const { vendorName } = useParams();
  const vendor = vendorName?.toLowerCase();
  const meta   = VENDOR_META[vendor];

  const [step, setStep]           = useState(0);
  const [accountType, setAccountType] = useState('');
  const [services, setServices]   = useState([]);
  const [credentials, setCredentials] = useState({});
  const [loading, setLoading]     = useState(false);
  const [toast, setToast]         = useState(null);

  const navigate = useNavigate();

  const setField = (key) => (e) =>
    setCredentials(prev => ({ ...prev, [key]: e.target.value }));

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 5000);
    return () => clearTimeout(t);
  }, [toast]);

  if (!meta) {
    return (
      <div className="vd-page">
        <div className="vd-unknown">
          <i className="fas fa-question-circle" />
          <p>{t('VendorDetailsPage.unknownVendorBefore')}"<strong>{vendorName}</strong>"{t('VendorDetailsPage.unknownVendorAfter')}</p>
          <button className="vd-back-link" onClick={() => navigate('/dashboard/vendors/cards')}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.backToVendorSelection')}
          </button>
        </div>
      </div>
    );
  }

  const toggleService = (id) =>
    setServices(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);

  /* ── Submit ──────────────────────────────────────────────────── */
  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      // Backend upper-cases vendorType; names with spaces (e.g. "Google Workspace" -> GOOGLE_WORKSPACE)
      // or brand prefixes (e.g. "Cisco Duo" -> DUO) need an explicit key that matches SUPPORTED_VENDORS.
      vendorType:       meta.vendorType || meta.name,
      accountType,
      selectedServices: services,
      credentials,
    };
    // Detect CPA/CISO client context handed off by VendorCards. When present, route the
    // POST to the partner-context endpoint so the connection is attributed to the client org.
    let cpaCtx = null;
    try { cpaCtx = JSON.parse(sessionStorage.getItem('cpaClientContext') || 'null'); } catch { /* ignore */ }
    const endpoint = cpaCtx?.orgId
      ? `/partner/context/clients/${cpaCtx.orgId}/vendors/connect`
      : '/vendors/connect';
    try {
      const response = await axiosInstance.post(endpoint, payload);
      if (response.status === 200) {
        const message = cpaCtx?.orgName
          ? t('VendorDetailsPage.connectedSuccessForOrg', { name: meta.name, org: cpaCtx.orgName })
          : t('VendorDetailsPage.connectedSuccess', { name: meta.name });
        setToast({ type: 'success', message });
        const returnPath = cpaCtx?.orgId
          ? '/dashboard/marketplace?cpaClientReturn=' + cpaCtx.orgId
          : '/dashboard/vendors';
        // Keep cpaClientContext until the CPA dashboard reads it on return; clear on plain return.
        if (!cpaCtx?.orgId) sessionStorage.removeItem('cpaClientContext');
        setTimeout(() => navigate(returnPath), 1800);
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data?.error || t('VendorDetailsPage.genericError');
      setToast({ type: 'error', message: msg });
    } finally {
      setLoading(false);
    }
  };

  /* ── Generic simple-form renderer ───────────────────────────── */
  const renderSimpleForm = () => {
    const flow = VENDOR_FLOWS[vendor];
    if (!flow) return null;
    const valid = flow.isValid(credentials);

    return (
      <>
        <div className="vd-step-title">{flow.title}</div>

        <InfoBox title={flow.instructions.heading}>
          <ol className="vd-inst-list">
            {flow.instructions.steps.map((s, i) => <li key={i}>{s}</li>)}
          </ol>
        </InfoBox>

        <div className="vd-fields">
          {flow.fields.map(f => (
            <div className="vd-field" key={f.key}>
              <label className="vd-label" htmlFor={f.key}>{f.label}</label>
              {f.type === 'textarea' ? (
                <textarea
                  id={f.key}
                  className="vd-input vd-textarea"
                  value={credentials[f.key] || ''}
                  onChange={setField(f.key)}
                  placeholder={f.placeholder}
                  rows={5}
                />
              ) : f.type === 'select' ? (
                <select
                  id={f.key}
                  className="vd-input"
                  value={credentials[f.key] || f.defaultValue || ''}
                  onChange={setField(f.key)}
                >
                  {(f.options || []).map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              ) : (
                <input
                  id={f.key}
                  className="vd-input"
                  type={f.type}
                  value={credentials[f.key] || ''}
                  onChange={setField(f.key)}
                  placeholder={f.placeholder}
                />
              )}
            </div>
          ))}
        </div>

        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => navigate('/dashboard/vendors/cards')}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button
            className="vd-btn-finish"
            style={{ background: meta.accent }}
            disabled={loading || !valid}
            onClick={handleSubmit}
          >
            {loading
              ? <><span className="vd-spinner" /> {t('VendorDetailsPage.connecting')}</>
              : t('VendorDetailsPage.connectVendor', { name: meta.name })}
          </button>
        </div>
      </>
    );
  };

  /* ── AWS flow (3 steps) ──────────────────────────────────────── */
  const renderAWS = () => {
    const accountOptions = [
      { value: 'Organization', icon: 'fa-building', label: t('VendorDetailsPage.awsOrgLabel'),
        desc: t('VendorDetailsPage.awsOrgDesc'),
        features: [t('VendorDetailsPage.awsOrgFeature1'), t('VendorDetailsPage.awsOrgFeature2'), t('VendorDetailsPage.awsOrgFeature3')] },
      { value: 'Single', icon: 'fa-user', label: t('VendorDetailsPage.awsSingleLabel'),
        desc: t('VendorDetailsPage.awsSingleDesc'),
        features: [t('VendorDetailsPage.awsSingleFeature1'), t('VendorDetailsPage.awsSingleFeature2'), t('VendorDetailsPage.awsSingleFeature3')] },
    ];

    if (step === 0) return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.awsStep0Title')}</div>
        <TypePicker options={accountOptions} selected={accountType} onSelect={setAccountType} />
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => navigate('/dashboard/vendors/cards')}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-next" disabled={!accountType} onClick={() => setStep(1)}>
            {t('VendorDetailsPage.next')} <i className="fas fa-arrow-right" />
          </button>
        </div>
      </>
    );

    if (step === 1) return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.awsStep1Title')}</div>
        <div className="vd-step-sub">{t('VendorDetailsPage.awsStep1Sub')}</div>
        <ServicePicker services={AWS_SERVICES} selected={services} onToggle={toggleService} />
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => setStep(0)}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-next" disabled={services.length === 0} onClick={() => setStep(2)}>
            {t('VendorDetailsPage.next')} <i className="fas fa-arrow-right" />
          </button>
        </div>
      </>
    );

    return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.awsStep2Title')}</div>
        <InfoBox title={t('VendorDetailsPage.awsStep2InfoTitle')}>
          <ol className="vd-inst-list">
            <li>Sign into the <a href="https://console.aws.amazon.com/iam/home#/roles" target="_blank" rel="noopener noreferrer">AWS IAM Console</a> and click <strong>Create role</strong>.</li>
            <li>Under <em>Trusted entity type</em>, select <strong>AWS account → Another AWS account</strong>.</li>
            <li>Enter the CATAAM platform account ID: <strong><code>615299771288</code></strong>.</li>
            <li>Attach the <strong>ReadOnlyAccess</strong> managed policy (and optionally <strong>SecurityAudit</strong>).</li>
            <li>Name the role <code>CATAAM-ReadRole</code> and click <strong>Create role</strong>.</li>
            <li>Copy the role <strong>ARN</strong> — format: <code>arn:aws:iam::123456789012:role/CATAAM-ReadRole</code></li>
          </ol>
        </InfoBox>
        <div className="vd-field">
          <label className="vd-label" htmlFor="iamArn">{t('VendorDetailsPage.iamRoleArnLabel')}</label>
          <input id="iamArn" className="vd-input" type="text"
            value={credentials.iamArn || ''}
            onChange={setField('iamArn')}
            placeholder="arn:aws:iam::123456789012:role/CATAAM-ReadRole" />
          {credentials.iamArn && credentials.iamArn.length < 20 && (
            <span className="vd-field-error">{t('VendorDetailsPage.iamArnError')}</span>
          )}
        </div>
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => setStep(1)}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-finish" style={{ background: meta.accent }}
            disabled={loading || !credentials.iamArn || credentials.iamArn.length < 20}
            onClick={handleSubmit}>
            {loading ? <><span className="vd-spinner" /> {t('VendorDetailsPage.connecting')}</> : t('VendorDetailsPage.connectAws')}
          </button>
        </div>
      </>
    );
  };

  /* ── Azure flow (3 steps) ────────────────────────────────────── */
  const renderAzure = () => {
    const envOptions = [
      { value: 'Enterprise', icon: 'fa-building', label: t('VendorDetailsPage.azureEnterpriseLabel'),
        desc: t('VendorDetailsPage.azureEnterpriseDesc'),
        features: [t('VendorDetailsPage.azureEnterpriseFeature1'), t('VendorDetailsPage.azureEnterpriseFeature2'), t('VendorDetailsPage.azureEnterpriseFeature3')] },
      { value: 'Personal', icon: 'fa-user', label: t('VendorDetailsPage.azurePersonalLabel'),
        desc: t('VendorDetailsPage.azurePersonalDesc'),
        features: [t('VendorDetailsPage.azurePersonalFeature1'), t('VendorDetailsPage.azurePersonalFeature2'), t('VendorDetailsPage.azurePersonalFeature3')] },
    ];

    if (step === 0) return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.azureStep0Title')}</div>
        <TypePicker options={envOptions} selected={accountType} onSelect={setAccountType} />
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => navigate('/dashboard/vendors/cards')}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-next" disabled={!accountType} onClick={() => setStep(1)}>
            {t('VendorDetailsPage.next')} <i className="fas fa-arrow-right" />
          </button>
        </div>
      </>
    );

    if (step === 1) return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.azureStep1Title')}</div>
        <div className="vd-step-sub">{t('VendorDetailsPage.azureStep1Sub')}</div>
        <ServicePicker services={AZURE_SERVICES} selected={services} onToggle={toggleService} />
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => setStep(0)}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-next" disabled={services.length === 0} onClick={() => setStep(2)}>
            {t('VendorDetailsPage.next')} <i className="fas fa-arrow-right" />
          </button>
        </div>
      </>
    );

    return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.azureStep2Title')}</div>
        <InfoBox title={t('VendorDetailsPage.azureStep2InfoTitle')}>
          <ol className="vd-inst-list">
            <li>Go to <a href="https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationsListBlade" target="_blank" rel="noopener noreferrer">Azure Portal → App registrations</a> and click <strong>New registration</strong>.</li>
            <li>Enter a name (e.g., <code>CATAAM Integration</code>), leave defaults, and click <strong>Register</strong>.</li>
            <li>Copy the <strong>Application (client) ID</strong> and <strong>Directory (tenant) ID</strong> from the Overview page.</li>
            <li>Go to <strong>Certificates &amp; secrets → Client secrets → New client secret</strong>. Copy the secret <strong>Value</strong>.</li>
            <li>Go to <strong>API permissions → Add → Microsoft Graph → Application permissions</strong>. Add <code>Directory.Read.All</code> and <code>User.Read.All</code>, then grant admin consent.</li>
          </ol>
        </InfoBox>
        <div className="vd-fields">
          <div className="vd-field">
            <label className="vd-label" htmlFor="azureTenant">{t('VendorDetailsPage.tenantIdLabel')}</label>
            <input id="azureTenant" className="vd-input" type="text"
              value={credentials.tenantId || ''}
              onChange={setField('tenantId')}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
          </div>
          <div className="vd-field">
            <label className="vd-label" htmlFor="azureSubscription">{t('VendorDetailsPage.subscriptionIdLabel')}</label>
            <input id="azureSubscription" className="vd-input" type="text"
              value={credentials.subscriptionId || ''}
              onChange={setField('subscriptionId')}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
          </div>
          <div className="vd-field">
            <label className="vd-label" htmlFor="azureClient">{t('VendorDetailsPage.clientIdLabel')}</label>
            <input id="azureClient" className="vd-input" type="text"
              value={credentials.clientId || ''}
              onChange={setField('clientId')}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
          </div>
          <div className="vd-field">
            <label className="vd-label" htmlFor="azureSecret">{t('VendorDetailsPage.clientSecretLabel')}</label>
            <input id="azureSecret" className="vd-input" type="password"
              value={credentials.clientSecret || ''}
              onChange={setField('clientSecret')}
              placeholder={t('VendorDetailsPage.enterClientSecretPlaceholder')} />
          </div>
        </div>
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => setStep(1)}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-finish" style={{ background: meta.accent }}
            disabled={loading || !credentials.tenantId || !credentials.subscriptionId || !credentials.clientId || !credentials.clientSecret}
            onClick={handleSubmit}>
            {loading ? <><span className="vd-spinner" /> {t('VendorDetailsPage.connecting')}</> : t('VendorDetailsPage.connectAzure')}
          </button>
        </div>
      </>
    );
  };

  /* ── GCP flow (3 steps) ──────────────────────────────────────── */
  const renderGCP = () => {
    const accountOptions = [
      { value: 'Organization', icon: 'fa-building', label: t('VendorDetailsPage.gcpOrgLabel'),
        desc: t('VendorDetailsPage.gcpOrgDesc'),
        features: [t('VendorDetailsPage.gcpOrgFeature1'), t('VendorDetailsPage.gcpOrgFeature2'), t('VendorDetailsPage.gcpOrgFeature3')] },
      { value: 'Personal', icon: 'fa-user', label: t('VendorDetailsPage.gcpPersonalLabel'),
        desc: t('VendorDetailsPage.gcpPersonalDesc'),
        features: [t('VendorDetailsPage.gcpPersonalFeature1'), t('VendorDetailsPage.gcpPersonalFeature2'), t('VendorDetailsPage.gcpPersonalFeature3')] },
    ];

    if (step === 0) return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.gcpStep0Title')}</div>
        <TypePicker options={accountOptions} selected={accountType} onSelect={setAccountType} />
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => navigate('/dashboard/vendors/cards')}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-next" disabled={!accountType} onClick={() => setStep(1)}>
            {t('VendorDetailsPage.next')} <i className="fas fa-arrow-right" />
          </button>
        </div>
      </>
    );

    if (step === 1) return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.gcpStep1Title')}</div>
        <div className="vd-step-sub">{t('VendorDetailsPage.gcpStep1Sub')}</div>
        <ServicePicker services={GCP_PRODUCTS} selected={services} onToggle={toggleService} />
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => setStep(0)}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-next" disabled={services.length === 0} onClick={() => setStep(2)}>
            {t('VendorDetailsPage.next')} <i className="fas fa-arrow-right" />
          </button>
        </div>
      </>
    );

    return (
      <>
        <div className="vd-step-title">{t('VendorDetailsPage.gcpStep2Title')}</div>
        <InfoBox title={t('VendorDetailsPage.gcpStep2InfoTitle')}>
          <ol className="vd-inst-list">
            <li>Go to <a href="https://console.cloud.google.com/iam-admin/serviceaccounts" target="_blank" rel="noopener noreferrer">GCP Console → IAM &amp; Admin → Service Accounts</a> and click <strong>+ CREATE SERVICE ACCOUNT</strong>.</li>
            <li>Name it <code>cataam-reader</code> and click <strong>Create and Continue</strong>.</li>
            <li>Assign roles: <strong>Viewer</strong>, <strong>Storage Admin</strong>, <strong>Security Reviewer</strong>, then click <strong>Continue → Done</strong>.</li>
            <li>Find the service account, click <strong>⋮ Actions → Manage keys → Add key → JSON</strong>. A key file will download.</li>
            <li>Open the JSON file and paste its full contents into the field below.</li>
            <li>Copy your <a href="https://console.cloud.google.com/project" target="_blank" rel="noopener noreferrer">Project ID</a> from the GCP project dashboard.</li>
          </ol>
        </InfoBox>
        <div className="vd-fields">
          <div className="vd-field">
            <label className="vd-label" htmlFor="gcpKey">{t('VendorDetailsPage.gcpServiceAccountKeyLabel')}</label>
            <textarea id="gcpKey" className="vd-input vd-textarea"
              value={credentials.gcpServiceAccountKey || ''}
              onChange={setField('gcpServiceAccountKey')}
              placeholder={t('VendorDetailsPage.gcpKeyPlaceholder')}
              rows={5} />
          </div>
          <div className="vd-field">
            <label className="vd-label" htmlFor="gcpProject">{t('VendorDetailsPage.projectIdLabel')}</label>
            <input id="gcpProject" className="vd-input" type="text"
              value={credentials.gcpProjectId || ''}
              onChange={setField('gcpProjectId')}
              placeholder="my-project-123456" />
          </div>
        </div>
        <div className="vd-nav">
          <button className="vd-btn-back" onClick={() => setStep(1)}>
            <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
          </button>
          <button className="vd-btn-finish" style={{ background: meta.accent }}
            disabled={loading || !credentials.gcpServiceAccountKey || !credentials.gcpProjectId}
            onClick={handleSubmit}>
            {loading ? <><span className="vd-spinner" /> {t('VendorDetailsPage.connecting')}</> : t('VendorDetailsPage.connectGcp')}
          </button>
        </div>
      </>
    );
  };

  /* ── Jira flow (1 step) ──────────────────────────────────────── */
  const renderJira = () => (
    <>
      <div className="vd-step-title">{t('VendorDetailsPage.jiraTitle')}</div>
      <InfoBox title={t('VendorDetailsPage.jiraInfoTitle')}>
        <ol className="vd-inst-list">
          <li>Log into <a href="https://id.atlassian.com/manage-profile/security/api-tokens" target="_blank" rel="noopener noreferrer">Atlassian Account Security</a>.</li>
          <li>Click <strong>Create API token</strong>, give it a label (e.g., <code>CATAAM</code>), and click <strong>Create</strong>.</li>
          <li>Copy the token immediately — it won't be shown again.</li>
          <li>Your domain is the subdomain of your Jira instance, e.g., <code>yourcompany.atlassian.net</code> → enter just <code>yourcompany</code>.</li>
        </ol>
      </InfoBox>
      <div className="vd-fields">
        <div className="vd-field">
          <label className="vd-label" htmlFor="jiraUser">{t('VendorDetailsPage.jiraUsernameLabel')}</label>
          <div className="vd-input-icon-wrap">
            <i className="fas fa-at vd-input-icon" />
            <input id="jiraUser" className="vd-input vd-input-with-icon" type="text"
              value={credentials.jiraUserName || ''}
              onChange={setField('jiraUserName')}
              placeholder="you@yourcompany.com" />
          </div>
        </div>
        <div className="vd-field">
          <label className="vd-label" htmlFor="jiraApiToken">{t('VendorDetailsPage.apiTokenLabel')}</label>
          <div className="vd-input-icon-wrap">
            <i className="fas fa-key vd-input-icon" />
            <input id="jiraApiToken" className="vd-input vd-input-with-icon" type="password"
              value={credentials.jiraToken || ''}
              onChange={setField('jiraToken')}
              placeholder={t('VendorDetailsPage.jiraTokenPlaceholder')} />
          </div>
        </div>
        <div className="vd-field">
          <label className="vd-label" htmlFor="jiraDomain">{t('VendorDetailsPage.jiraDomainLabel')}</label>
          <div className="vd-input-icon-wrap">
            <i className="fas fa-globe vd-input-icon" />
            <input id="jiraDomain" className="vd-input vd-input-with-icon" type="text"
              value={credentials.jiraDomainName || ''}
              onChange={setField('jiraDomainName')}
              placeholder="yourcompany" />
          </div>
        </div>
      </div>
      <div className="vd-nav">
        <button className="vd-btn-back" onClick={() => navigate('/dashboard/vendors/cards')}>
          <i className="fas fa-arrow-left" /> {t('VendorDetailsPage.back')}
        </button>
        <button className="vd-btn-finish" style={{ background: meta.accent }}
          disabled={loading || !credentials.jiraUserName || !credentials.jiraToken || !credentials.jiraDomainName}
          onClick={handleSubmit}>
          {loading ? <><span className="vd-spinner" /> {t('VendorDetailsPage.connecting')}</> : t('VendorDetailsPage.connectJira')}
        </button>
      </div>
    </>
  );

  /* ── Route to the right renderer ─────────────────────────────── */
  const renderStep = () => {
    if (vendor === 'aws')   return renderAWS();
    if (vendor === 'azure') return renderAzure();
    if (vendor === 'gcp')   return renderGCP();
    if (vendor === 'jira')  return renderJira();
    return renderSimpleForm();
  };

  const multiStep = meta.stepLabels.length > 1;

  return (
    <div className="vd-page">
      {toast && (
        <div className={`vd-toast vd-toast-${toast.type}`}>
          <i className={`fas fa-${toast.type === 'success' ? 'check-circle' : 'exclamation-circle'}`} />
          {toast.message}
        </div>
      )}

      <div className="vd-card">
        <div className="vd-header">
          <div className="vd-vendor-badge">
            <img src={VENDOR_LOGOS[vendor]} alt={meta.name} className="vd-vendor-logo"
              onError={e => { e.target.style.display = 'none'; }} />
            <div>
              <div className="vd-vendor-name">{meta.name}</div>
              <div className="vd-vendor-sub">{t('VendorDetailsPage.vendorConnectionSetup')}</div>
              {integrationDocsUrl(vendor) && (
                <a className="vd-doc-link" href={integrationDocsUrl(vendor)} target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-book" /> {t('VendorDetailsPage.integrationDocs')}
                </a>
              )}
            </div>
          </div>
          {multiStep && <Stepper steps={meta.stepLabels} current={step} />}
        </div>

        <div className="vd-body">
          {renderStep()}
        </div>
      </div>
    </div>
  );
}

export default VendorDetailsPage;
